// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8cGF0aAogICAgIGQ9Ik0gMC4wNDAzODA1OSwwLjYyNjc3NjcgMC4xNDY0NDY2MSwwLjUyMDcxMDY4IDAuNDI5Mjg5MzIsMC44MDM1NTMzOSAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IE0gMC4yMTcxNTcyOSwwLjgwMzU1MzM5IDAuODUzNTUzMzksMC4xNjcxNTcyOSAwLjk1OTYxOTQxLDAuMjczMjIzMyAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IgogICAgIGlkPSJyZWN0Mzc4MCIKICAgICBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpub25lIiAvPgo8L3N2Zz4K", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxIDEiPjx0aXRsZT51bnRpdGxlZDwvdGl0bGU+PHBhdGggZD0iTTAsMFYxSDFWMEgwWk0wLjQ1LDAuNzRsLTAuMDguMDhMMC4yOCwwLjc0LDAuMTQsMC42bDAuMDgtLjA4TDAuMzYsMC42NWwwLjQxLS40MUwwLjg2LDAuMzJaIi8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --light-blue: #47c8ff;
    --light-black: #2d2d2d;
    --light-grey: #2d2d2d;
    --light-blue-gradient-background: linear-gradient(90deg, rgba(71, 163, 255, 0.999) 0%, rgba(0, 94, 239, 1) 100%);
    --light-blue-gradient-background-2: linear-gradient(90deg, rgba(191, 242, 255, 1) 0%, rgba(195, 215, 255, 1) 100%);
    --color-white: #fff;
    --color-blue: #005eef;
    --table-head-background: #f0f8ff;
    --table-head-border: 0.5px solid rgba(71, 200, 255, 0.9); /* Stroke with 90% opacity */
    --table-head-box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    --table-body-cell-background: linear-gradient(180deg, rgba(217, 247, 255, 1) 0%, rgba(195, 215, 255, 1) 100%);
}
table,
tr,
td {
    height: 100%;
}
.color-white {
    color: var(--color-white) !important;
}

.color-blue {
    color: var(--color-blue) !important;
}

.color-black {
    color: var(--light-black) !important;
}

.color-disabled {
    color: var(--light-grey) !important;
}

.white-background {
    background: #fff;
}

.b {
    border: 1px solid red;
}

.b2 {
    border: 1px solid green;
}

.b3 {
    border: 1px solid rgb(21, 0, 128);
}

.header-container {
    min-height: 65px;
}

.brand-logo--header {
    height: 40px;
    width: 40px;
    filter: brightness(0) invert(1);
}

.header-icons-container {
    float: right;
    z-index: 3;
}

.header-icons-container span {
    cursor: pointer;
}

.header-logo-container {
    display: flex;
    justify-items: center;
}

.vl {
    border-left: 1px solid #fff;
    height: 38px;
    margin-top: 2px;
    width: 0px;
    margin-left: 5px;
}

.vl-2 {
    border-left: 2px solid #49505772;
    height: auto;
    margin-top: 5px;
    margin-bottom: 5px;
    width: 0px;
}

.full-container {
    border-radius: 10px;
}

.full-container m-4 {
    max-height: 100%;
    border-radius: 10px;
}

.dropdown-card {
    min-height: 145px;
    border-radius: 0px 0px 5px 5px;
    margin: 0px auto;
    font-size: 12px;
    background-color: #fff;
}

.card-btns {
    display: flex;
    justify-content: space-between;
}

.disabled-btn {
    background-color: grey !important;
    color: #fff !important;
}

.disabled {
    cursor: default !important;
    pointer-events: none !important;
    color: grey;
}

.dropdown-card-image {
    height: 100px;
    width: 100%;
}

.dropdown-cards-image-container {
    padding: 5px 5px 0px 5px;
}

.dropdown-card-dropdown-container {
    padding: 5px;
}

.dropdown-first-row {
    z-index: 5 !important;
}

.dropdown-correlation {
    width: 450px !important;
    border-radius: 0px 0px 5px 5px;
    margin: 0px auto;
    font-size: 12px;
    background-color: #fff;
}

.dropdown-driver-analysis {
    border-radius: 0px 0px 5px 5px;
    margin-left: 28px;
    font-size: 12px;
    background-color: #fff;
}

.dropdown-cards-image-container > button,
.dropdown-card > .dropdown-card-dropdown-container > .dropdown > div,
.dropdown-card-dropdown-container > input,
.dropdown-card > .dropdown-card-dropdown-container > .custom-file > label {
    background: var(--light-blue-gradient-background-2) !important;
}

.dialogue-input-label-container {
    margin: 5px 0px 10px 0px;
}

.dialogue-dropdown > .css-13cymwt-control,
.dialogue-dropdown > .css-t3ipsp-control {
    min-height: unset !important;
}

.dialogue-dropdown > div > .css-1hb7zxy-IndicatorsContainer > .css-1xc3v61-indicatorContainer,
.dialogue-dropdown > div > .css-1hb7zxy-IndicatorsContainer > .css-15lsz6c-indicatorContainer {
    padding: 12px 0px;
}

.dropdown > .css-1nmdiq5-menu {
    z-index: 2 !important;
}

:where(.css-dev-only-do-not-override-1jr9qlj).ant-picker-dropdown {
    z-index: 10999999 !important;
}

.ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel .ant-picker-content,
:where(.css-dev-only-do-not-override-1jr9qlj).ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel table {
    height: 24px;
}

.date-picker-pop-up-calendar {
    z-index: 100000;
}

.multi-select-dropdowns > .css-13cymwt-control > .css-3w2yfm-ValueContainer {
    display: flex;
    flex-direction: row;
    overflow-y: scroll;
    overflow-x: scroll;
    height: 100%;
}

.multi-select-dropdowns > .css-13cymwt-control > .css-3w2yfm-ValueContainer .css-1p3m7a8-multiValue {
    min-width: unset;
}

.tabs-container > div > div {
    margin-top: 10px;
    background-color: #eee;
    display: inline-block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}

.search-bar-input:focus {
    outline: none;
    border: 1px solid var(--color-blue);
}

.search-bar-input {
    outline: none;
    border: 1px solid var(--color-blue);
    border-radius: 3px 0px 0px 3px;
}

.css-1betqn-MuiAccordionSummary-content {
    margin: 0px !important;
}

.tab-labels {
    text-transform: unset !important;
    background-color: #eee;
    padding: 10px 20px !important;
    min-height: unset !important;
    font-size: 14px !important;
}

.tab-labels svg {
    font-size: 1rem;
}

.footer {
    height: 38px;
}

.tab--edit-button {
    display: block;
}

.tab--edit-button button {
    right: 0;
}

.error-404--container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translateY(-50%);
    -ms-transform: translateX(50%);
}

.error-404--container h1 {
    color: #4d4d4d;
    letter-spacing: 4px;
}

.error-404--container img {
    width: 500px;
}

.page-name--title {
    text-transform: uppercase;
}

.header-title-suffix {
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: 0.4px;
    margin-left: 6px;
    opacity: 0.85;
    text-transform: none;
}

.tabs-toggle div div .tab-labels {
    background-color: #eee;
    border-radius: 4px;
    padding: 0.55rem !important;
}

.tabs-toggle div div .tab-labels.Mui-selected {
    color: #fff;
    background: var(--light-blue-gradient-background) !important;
}

.outlined-vtn-container--data-seeding {
    position: relative;
    right: calc(-100% + 55px);
    display: inline;
    top: -62px;
}

.text-input {
    width: 100%;
    height: 29px;
    border-radius: 4px;
    border: none;
    border-style: solid;
    border-width: 1px;
    outline-color: var(--color-blue);
    border-color: hsl(0, 0%, 80%);
    font-weight: 400;
    font-size: 10px;
    line-height: 1.5;
    letter-spacing: 0.00938em;
    padding: 0px 10px;
}

.text-input:focus {
    border: 1px solid var(--color-blue);
    outline: 1px solid var(--color-blue);
}

.custom-btn-outlined > span > svg {
    font-size: 15px !important;
}

.horizontal-menu {
    display: flex;
}

.menu-list {
    display: flex !important;
    justify-content: center;
    flex-direction: column;
}

.menu-list a {
    color: inherit;
    text-decoration: none;
}

.edit--dialogue > div {
    margin: 20px 30px;
}

.input-label-dialog {
    color: #424242d4 !important;
    font-size: 13px !important;
    padding-bottom: 5px !important;
    font-weight: 600 !important;
}

.text-input-dialog {
    width: 100%;
    border-radius: 4px;
    border: none;
    border-style: solid;
    border-width: 1px;
    outline-color: var(--color-blue);
    border-color: hsl(0, 0%, 80%);
    outline: none;
    font-weight: 400;
    letter-spacing: 0.00938em;
    padding: 7px 10px;
}

.text-input-dialog:focus {
    border: 1px solid var(--color-blue);
    outline: 1px solid var(--color-blue);
}

.dropdown-dialog .css-13cymwt-control > .css-1fdsijx-ValueContainer > .css-1dimb5e-singleValue,
.dropdown-dialog .css-13cymwt-control > .css-1fdsijx-ValueContainer > .css-qbdosj-I.nput > input {
    color: var(--color-blue) !important;
}

.month-year--picker,
.month-year--picker:hover {
    padding: 0px 10px;
    width: 100%;
    height: 31.6px;
    border-radius: 4px;
    border: none;
    border-style: solid;
    border-width: 1px;
    outline: none;
    border-color: hsl(0, 0%, 80%);
}

.month-year--picker > .ant-picker-input > input {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.00938em;
}

.month-year--picker > .ant-picker-input > input::placeholder {
    font-size: 12px;
    color: hsl(0, 0%, 50%);
}

.ant-picker-dropdown {
    z-index: 9999 !important;
}

/* badge drawer */
.badge-drawer-button {
    min-height: min-content;
    position: sticky;
    top: 120px;
    float: right;
    clear: both;
    display: inline;
    padding: 7px 7px 7px 2px;
    border-radius: 20px 0px 0px 20px;
    background: rgb(0, 94, 239);
    background: linear-gradient(90deg, rgba(0, 94, 239, 0.11668417366946782) 0%, rgba(209, 209, 209, 1) 100%);
}

.badge-drawer-button > span {
    min-height: max-content;
    color: #fff;
    height: auto !important;
    background-color: var(--color-blue);
    padding: 7px 7px;
    border-radius: 50%;
    cursor: pointer;
}

.badge-drawer-button > span > .css-i4bv87-MuiSvgIcon-root {
    height: auto !important;
}

/* landing page */
.landing-page-table > div > table > thead > tr > th > div > svg {
    font-size: 20px;
    margin-top: 10px;
}

.landing-page-table > div > table > thead > tr > th > div > p {
    font-size: 12px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.landing-page-table > div > table {
    min-height: calc(100vh - 260px);
    max-height: calc(100vh - 260px);
    height: calc(100vh - 260px);
    margin-bottom: 0px;
}

.compare-labels-container {
    display: flex;
    justify-content: space-around;
    height: auto;
}

.compare-labels-container > div {
    display: flex;
    align-items: center;
    max-width: 300px;
}

.compare-labels-container > div > p {
    margin-bottom: 0px;
    color: #4d4d4d;
    letter-spacing: 0.8px;
}

ul.dialog-list {
    list-style: none;
    padding-left: 20px;
}

ul.dialog-list li {
    margin-top: 20px;
}

.dialog-list-icon {
    color: var(--color-blue);
    font-size: 20px;
    margin-right: 10px;
}

.dialog-errorMessage {
    background-color: #d2d2d2;
    padding: 10px 40px;
}

.upload-container {
    display: flex;
    margin: 20px 0px;
}

.custom-file--W-400 {
    width: 400px !important;
}

.custom-file {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 28px;
    margin-bottom: 0;
}

.custom-file-input {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 28px;
    margin: 0;
    overflow: hidden;
    opacity: 0;
    cursor: pointer;
}

.custom-file-label {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
    height: 28px;
    padding: 0.375rem 0.75rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    width: 100%;
    overflow: hidden;
    font-size: 10px;
}

.custom-file-label::after {
    letter-spacing: 0.5px;
    font-weight: 500;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: 28px;
    padding: 0.6rem 0.75rem;
    line-height: 1;
    color: var(--color-blue);
    content: "Browse File";
    background-color: #e9ecef;
    border-left: inherit;
    border-radius: 0 0.25rem 0.25rem 0;
}

/* filters */
.remove-opacity {
    opacity: 1 !important;
    transform: scale(1.1);
    pointer-events: unset !important;
}

.enable-filter {
    opacity: 0.8 !important;
    pointer-events: unset !important;
}

.filter-key-box > button {
    opacity: 0.4;
    margin: 10px auto 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: ease-out 0.1s;
    pointer-events: none;
    border: none;
    outline: none;
}

.filter-key-box > button > span {
    font-weight: 600;
    padding-top: 5px;
}

.filter-img-box {
    overflow: hidden;
    border-radius: 5px 5px;
}

.filter-img-box img {
    height: 70px;
    width: 100px;
}

/* input labels and container product details*/

.product-details-input-labels-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0px 20px 0px;
}

.product-details-input-labels-container label {
    color: #424242d4 !important;
    font-size: 13px !important;
    font-weight: 600 !important;
}

.product-details-input-labels-container input {
    color: #424242d4 !important;
    font-size: 13px !important;
    width: 70%;
    outline: none;
    padding: 1px 10px;
    border: 1px solid #49505772;
    border-radius: 3px;
}

.product-details-input-labels-container p {
    color: #424242d4 !important;
    font-size: 13px !important;
    width: 70%;
    padding: 1px 10px;
    border: 1px solid #49505772;
    border-radius: 3px;
    min-height: 25px;
    margin-top: 0;
    margin-bottom: 0;
    text-wrap: wrap;
    word-break: break-all;
}

.product-details-input-labels-container a {
    font-size: 13px !important;
    width: 70%;
    outline: none;
    padding: 1px 10px;
    border: 1px solid #49505772;
    border-radius: 3px;
    word-break: break-all;
}

.product-details-label {
    width: 150px;
}

/* loader*/
.loader-container {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* background-color: rgba(0, 0, 0, 0.5); */
    z-index: 2;
}

#page {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

#container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

#h3 {
    /* color: white; */
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 1px;
}

#ring {
    width: 190px;
    height: 190px;
    border: 1px solid transparent;
    border-radius: 50%;
    position: absolute;
}

#ring:nth-child(1) {
    border-bottom: 8px solid rgb(255, 141, 249);
    animation: rotate1 2s linear infinite;
}

@keyframes rotate1 {
    from {
        transform: rotateX(50deg) rotateZ(110deg);
    }

    to {
        transform: rotateX(50deg) rotateZ(470deg);
    }
}

#ring:nth-child(2) {
    border-bottom: 8px solid rgb(255, 65, 106);
    animation: rotate2 2s linear infinite;
}

@keyframes rotate2 {
    from {
        transform: rotateX(20deg) rotateY(50deg) rotateZ(20deg);
    }

    to {
        transform: rotateX(20deg) rotateY(50deg) rotateZ(380deg);
    }
}

#ring:nth-child(3) {
    border-bottom: 8px solid var(--color-blue);
    animation: rotate3 2s linear infinite;
}

@keyframes rotate3 {
    from {
        transform: rotateX(40deg) rotateY(130deg) rotateZ(450deg);
    }

    to {
        transform: rotateX(40deg) rotateY(130deg) rotateZ(90deg);
    }
}

#ring:nth-child(4) {
    border-bottom: 8px solid rgb(252, 183, 55);
    animation: rotate4 2s linear infinite;
}

@keyframes rotate4 {
    from {
        transform: rotateX(70deg) rotateZ(270deg);
    }

    to {
        transform: rotateX(70deg) rotateZ(630deg);
    }
}

/*t-test dialog css */
.test-type {
    background-color: #ffffff;
    border: 1px solid #335eea;
    border-radius: 4px;
    padding: 5px 0px;
    text-align: center;
    font-size: 14px;
}

.test-type-selected {
    background: var(--light-blue-gradient-background) !important;
    color: #ffffff;
}

.test-type-disabled {
    border: 1px solid #cccccc;
    color: #969696;
}

.radio-label {
    max-width: 25ch;
    margin-top: 8px;
}

.overall-table-column-hidden {
    color: transparent !important;
    font-size: 0px !important;
    padding: 0;
    max-width: 30px !important;
    white-space: nowrap !important;
}

.overall-table-sticky-row1 {
    position: sticky;
    left: 150px;
}

.overall-table-sticky-row2 {
    position: sticky;
    left: 450px;
    white-space: nowrap;
    overflow: visible;
}

.overall-table-sticky-row2-container {
    position: relative;
}

.overall-table-sticky-row2-content {
    position: stick;
    background-color: red;
    white-space: normal;
    overflow: visible;
    z-index: 1;
    min-width: 200px;
    /* Set a minimum width for the cell */
}

.overall-kip-tab > div {
    padding-top: 0px !important;
}

.ag-multi-line-cell-render span {
    display: block !important;
    padding: 0;
}

.ag-multi-line-cell-render p {
    line-height: 15px;
}

.ag-multi-line-cell-render :not(:first-child) {
    margin-top: -10px;
}

.ag-multi-line-cell-render :nth-child(1) {
    margin-top: 5px;
}

.move-button--hidden {
    transform: translate(0px, 100px);
    transition: ease-out 0.5s;
}

.move-button--visible {
    transform: translate(0px, 0px);
    transition: ease-out 0.5s;
}

/* X-Small devices (portrait phones, less than 576px) */
/* No media query for \`xs\` since this is the default in Bootstrap */

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
}

@media (max-width: 768px) {
    .outlined-vtn-container--data-seeding {
        display: block;
        position: unset;
        right: unset;
        top: unset;
    }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
}

/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}

/* XX-Large devices (larger desktops, 1400px and up) */
@media (min-width: 1400px) {
    .dropdown-card-image {
        min-height: 150px;
    }

    .dropdown-card {
        min-height: 195px;
    }
}

@media (min-width: 1920px) {
    .dropdown-card-image {
        min-height: 170px;
    }

    .dropdown-card {
        min-height: 215px;
    }
}

/* XX-Large devices (larger desktops, 1400px and up) */
@media (min-width: 2560px) {
    .dropdown-card-image {
        min-height: 190px;
    }

    .dropdown-card {
        min-height: 225px;
    }
}

/*Tooltip style*/
.fixed-height-tooltip {
    max-height: 42vh !important;
    overflow-y: auto;
    width: 25vw !important;
    border: rgb(222, 226, 230) solid 2px !important;
    border-radius: 5px !important;
}

::-webkit-scrollbar {
    width: 8px;
    height: 10px;
    background-color: #ffffff;
    border-radius: 5px;
}

::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #c2c9d2;
}

.custom_checkbox__input {
    position: absolute;
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
}

.custom_checkbox__label {
    font-weight: 600;
    position: relative;
    padding-left: 28px;
}

.custom_checkbox__label:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 18px;
    height: 18px;
    border: 2px rgba(0, 0, 0, 0.54) solid;
    box-sizing: border-box;
    border-radius: 3px;
}

.custom_checkbox__input:checked ~ .custom_checkbox__label:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-color: var(--color-blue);
    border-color: var(--color-blue);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.custom_checkbox__input[type="checkbox"]:disabled + label::before {
    background: #bdbdbd;
    border-color: #a1a1a1;
}

.custom_checkbox__input ~ .custom_checkbox__label:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
}

.custom_checkbox__input:checked ~ .custom_checkbox__label:after {
    background-color: var(--color-blue);
}

.input_border_color {
    border: 0.5px solid var(--color-blue);
    border-radius: 5px;
}

.input_border_color:focus {
    border-color: var(--color-blue);
    outline: none;
}

.missing-filters-tooltip {
    max-height: 42vh !important;
    overflow-y: auto;
    width: 100% !important;
    border-radius: 5px !important;
    box-shadow:
        rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
        rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}

.missing-filters-ul {
    font-size: 0.75rem;
    line-height: 23px;
    padding-left: 25px;
}

.missing-filters-ul li::marker {
    font-size: 7px;
}

.invert {
    filter: opacity(0.1);
}

.highlight {
    background-color: yellow;
    /* Highlight background */
}

/* style for action standard tabs */
.tab-system {
    width: 100%;
    margin: 0 auto;
    border-radius: 5px;
    padding: 10px;
}

.tab-nav {
    display: flex;
    margin-bottom: 10px;
    border-bottom: 1px solid gray;
}

.tab-item {
    padding: 5px 10px;
    display: flex;
    align-items: center;
    background-color: #f1f1f1;
    border: 1px solid gray;
    border-bottom: none;
}

.tab-item.active {
    background-color: #ffffff;
    border: 1px solid gray;
    border-bottom: none;
}

.tab-item button {
    background: none;
    border: none;
    margin-left: 5px;
}

.close-btn {
    color: red;
    font-weight: bold;
    cursor: pointer;
}

.add-btn {
    color: rgb(51, 94, 234);
    padding: 5px 10px;
    cursor: pointer;
    background-color: #ffffff;
    border: 1px solid gray;
    border-bottom: none;
    font-size: 14px;
    font-weight: 600;
}

.disable-add-btn {
    color: #989898;
    padding: 5px 10px;
    cursor: pointer;
    background-color: #e8e8e8;
    border: 1px solid #a8a8a8;
    border-bottom: none;
    font-size: 14px;
    font-weight: 600;
}

.tab-content {
    padding: 10px;
    border-radius: 5px;
}

/* style for action standard form */
.as-input-label {
    padding-top: 5px;
    margin-right: 5px;
    width: 37%;
}

.as-input-field {
    margin-right: 5px;
    width: 62%;
}

.as-input-container {
    display: flex;
    margin: 10px;
}

.as-kpi-label {
    width: 99%;
    background-color: #e8e8e8;
    font-weight: 700;
    text-align: center;
    height: 30px;
    padding: 5px;
}

.as-kpi-button {
    width: 99%;
    background-color: #00ff00;
    border: 1px solid #00ff00;
    font-weight: 700;
    text-align: center;
    height: 30px;
    color: #fff;
    margin-top: 10px;
}

.as-kpi-header {
    width: 90%;
    font-weight: 700;
    text-align: center;
    padding: 5px;
    margin: 20px;
}

.kpi-add-btn {
    border-radius: 50%;
    background-color: rgb(0, 255, 0);
    padding: 3px 8px;
    border: 1px solid rgb(0, 255, 0);
    color: rgb(255, 255, 255);
    font-weight: bold;
}

.kpi-remove-btn {
    border-radius: 50%;
    background-color: rgb(255, 0, 0);
    padding: 3px 8px;
    border: 1px solid rgb(255, 0, 0);
    color: rgb(255, 255, 255);
    font-weight: bold;
    margin: 0px 10px;
}

.condition-block {
    position: relative;
}

.condition-block .condition-remove-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    padding: 2px 8px;
    border-radius: 50%;
    background-color: red;
    color: white;
}

.as-textarea {
    border: 1px solid hsl(0, 0%, 80%);
    border-radius: 4px;
    background-color: rgba(239, 239, 239, 0.3);
    padding: 5px;
    width: 100%;
    min-height: 70px;
}

.input-label {
    display: block;
    color: rgb(48, 48, 48);
}

.input-label-select {
    display: block;
    max-width: 100%;
    min-height: 40px;
    width: 100%;
    border-radius: 5px;
    outline: none;
    color: rgb(48, 48, 48);
    transition-duration: 0.2s;
}

.input-label-field {
    display: block;
    max-width: 100%;
    height: 35px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid #dddddd;
    padding: 0px 12px;
    outline: none;
    caret-color: var(--color-blue);
    color: rgb(48, 48, 48);
    transition-duration: 0.2s;
}

.input-label-field-width-500 {
    min-width: 500px;
}

.input-label-select:focus {
    border: 2px solid var(--color-blue);
    transition-duration: 0.2s;
}

.input-label-field:focus {
    border: 2px solid var(--color-blue);
    transition-duration: 0.2s;
}

label.button,
.button {
    cursor: pointer;
}

.boxed label {
    display: inline-block;
    margin: 20px;
    width: 240px;
    padding: 7px 7px 5px;
    border: solid 4px var(--color-blue);
    transition: all 0.4s;
    border-radius: 10px;
    text-align: center;
    font-size: 18px;
    color: var(--color-blue);
}

.boxed input[type="radio"] {
    display: none;
}

.boxed input[type="radio"]:checked + label {
    background: var(--light-blue-gradient-background);
    color: var(--color-white);
}

.button-confirm {
    background-color: #00a6c9;
    border-color: transparent;
    padding: 10px 100px;
    color: #ffffff;
    background: #333;
    border-radius: 5px;
    border: 1px solid #fff;
}

.liner-light-blue-background {
    background: var(--light-blue);
    background: var(--light-blue-gradient-background);
}
.liner-light-blue-background-2 {
    background: var(--light-blue-gradient-background-2);
}

.css-byenzh-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked {
    color: #47c8ff !important;
}

.custom-btn-outlined-2 {
    color: var(--color-blue) !important;
    border-color: var(--light-blue) !important;
}

.image-white {
    filter: brightness(0) invert(1);
}

.custom-btn-outlined-3 {
    border-color: var(--light-blue) !important;
}

.table-chart-toggle-container {
    border-radius: 5px;
    border: 1px solid var(--light-blue);
    font-size: 12px;
    display: flex;
    padding: 1px;
}

.table-chart-toggle-container div {
    border-radius: 3px;
    padding: 3px 5px;
    cursor: pointer;
    width: 50%;
    text-align: center;
}

.table-seperator-row-height {
    height: 30px;
}
.table-seperator-head-height {
    height: 50px;
}

.table-seperator-blue {
    border-radius: 10px;
    width: 7px;
    background-color: #0060ef9e;
    position: relative;
    left: -7px;
    box-shadow: var(--table-head-box-shadow);
}
.table-seperator-col {
    border-radius: 10px;
    width: 7px;
    background-color: #0060ef9e;
    margin-right: 10px;
    box-shadow: var(--table-head-box-shadow);
    margin-left: -6px
}

.table-seperator-col-hair-skin {
    background-color: #619CF5;
}

.table-seperator-grey {
    border-radius: 10px;
    width: 7px;
    background-color: var(--table-head-background);
    position: relative;
    left: -7px;
    box-shadow: var(--table-head-box-shadow);
}
 
.table-seperator-grey-hair-skin {
    background-color: #619CF5;
}
.analysis-table > :not(caption) > * > * {
    border-bottom-width: 0px;
}

.analysis-table th > div > .table-head-cell {
    background: var(--table-head-background);
    box-shadow: var(--table-head-box-shadow);
    border-radius: 10px;
    color: var(--color-blue);
    height: 100%;
    width: 100%;
    padding: 5px;
}

.analysis-table td > div > .table-body-cell {
    color: #000;
    height: 100%;
    width: 100%;
}

.bold-content {
    font-weight: bold !important;
    letter-spacing: 0.4px !important;
}

.custom-btn--upload-reset.Mui-disabled {
    color: rgba(0, 0, 0, 0.6) !important;
}

.no-break {
    white-space: nowrap;
}

.gap {
    height: 15px;
    border-color: #ffffff;
}

.disabled-input {
    color: #999999;
}

.itm-td {
    transform: scale(0.8);
    animation: fadeInScale 1s ease-out forwards;
}

@keyframes fadeInScale {
    0% {
        opacity: 0;
        transform: scale(0.8);
    }
    50% {
        opacity: 1;
        transform: scale(1.05);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

.weighted-span {
    transform: scale(0.8);
    animation: fadeWeightedScale 1s ease-out forwards;
}

.score-span {
    background-color: #ffffffff;
}

@keyframes fadeWeightedScale {
    0% {
        opacity: 0;
        transform: scale(0.8);
    }
    50% {
        opacity: 1;
        transform: scale(1.05);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

.custom-swal-popup .swal2-html-container {
    font-size: 14px;
    line-height: 1.2;
    padding: 5px;
}

.custom-swal-popup .swal-text {
    margin: 5px;
}

.custom-swal-popup .swal2-actions {
    margin: 5px;
}

.custom-swal-popup .swal2-styled {
    margin: 5px;
    font-size: 12px;
    background: linear-gradient(90deg, rgba(71, 163, 255, 0.999) 0%, rgba(0, 94, 239, 1) 100%);
}
.swal2-container {
    z-index: 10000 !important;
}

.cp-tab-labels {
    text-transform: unset !important;
    font-weight: 600 !important;
}

.stm-form-group {
    margin-bottom: 16px;
    margin-top: 20px;
}

.stm-form-group label {
    display: inline-flex;
    margin-bottom: 6px;
    color: #333;
    width: 32%;
    font-size: 11px;
}

.stm-form-group input,
.stm-form-group select {
    width: 66%;
    padding: 10px;
    border-radius: 6px;
    border: none;
    background-color: #faf7f7;
    display: inline-flex;
    margin-left: 10px;
    font-size: 11px;
}

.stm-form-group input:focus {
    outline: 1px solid var(--color-blue);
}

.table-head-product-buttons {
    background: none;
    color: var(--color-blue);
    text-align: center;
    font-weight: 600;
    border: none;
}
.clean-button {
    outline: none;
    border: none;
    background: none;
}

.sign-in-box {
    background-color: #ededed;
    margin-top: 40px;
    text-align: center;
}
.sign-in-box-shadow {
    box-shadow: 0px 0px 40px -21px rgb(0 0 0);
}
.login-container {
    min-height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.uni-logo-login img {
    width: 250px;
    margin: 0px auto;
    padding: 30px;
    display: flex;
    align-items: center;
    filter: brightness(0) invert(1);
}
.uni-logo-login {
    background-color: #005eef;
    padding: 30px;
}
.sign-in-form {
    color: #005eef;
    padding: 20px;
}
.sign-in-form div h2 {
    text-transform: uppercase;
    margin-bottom: 0px !important;
}
.sign-in-form div p {
    font-weight: 600;
    margin-bottom: 0px !important;
    letter-spacing: 1px;
}
.sign-in-box button {
    width: 150px;
    border-radius: 20px;
    background-color: #005eef;
    padding: 8px 10px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.usage-layout-container {
    padding: 16px;
    font-family: Arial, sans-serif;
}

.usage-grid-header {
    display: grid;
    gap: 16px;
    margin-bottom: 8px;
    align-items: end;
}

.header-cell {
    font-size: 14px;
    font-weight: 600;
    color: rgb(51, 94, 234);
    min-height: 40px;
    padding-bottom: 4px;
}

.header-cell.label-header {
    text-align: left;
}

.header-cell.product-header {
    text-align: center;
}

.usage-grid-container {
    display: grid;
    gap: 16px;
}

.grid-cell {
    display: flex;
    align-items: center;
    border: 1px solid rgb(51, 94, 234);
    border-radius: 8px;
    height: 38px;
    box-sizing: border-box;
}

.grid-cell.label-cell {
    justify-content: flex-start;
    padding-left: 16px;
    font-size: 14px;
    color: #333;
}

.grid-cell.data-cell {
    padding: 0;
}

.table-input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    padding: 8px 16px;
    box-sizing: border-box;
    text-align: center;
    background-color: transparent;
    font-size: 14px;
    border-radius: 8px;
}

.table-input:read-only {
    cursor: default;
    color: #555;
}

.table-input.editable {
    background-color: #fff;
}

.table-input.editable:focus {
    box-shadow: 0 0 0 2px rgba(51, 94, 234, 0.4);
}

/* Text Theme Analysis */
.tta-filter-header {
    border-radius: 5px;
}

.tta-study-info-row {
    align-items: baseline;
    color: var(--color-blue);
    display: flex;
    flex-wrap: nowrap;
    font-size: 9.5px;
    line-height: 1.1;
    overflow: hidden;
    padding: 6px 0;
    white-space: nowrap;
    width: 100%;
}

.tta-study-info-item {
    align-items: baseline;
    display: flex;
    flex: 0 0 auto;
    white-space: nowrap;
}

.tta-study-info-row .text-xs {
    font-size: 10.5px !important;
    line-height: 1.1;
}

.tta-study-info-row .ps-2 {
    padding-left: 0.35rem !important;
}

.tta-study-info-row .pe-3 {
    padding-right: 0.55rem !important;
}

.tta-page {
    min-height: calc(100vh - 150px);
    padding: 7px 9px 82px 0;
    position: relative;
}

.tta-back {
    align-items: center;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    left: -15px;
    position: absolute;
    top: -15px;
    z-index: 4;
}

.tta-main-content {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding-left: 0;
}

.tta-section-group {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.tta-section-wrapper {
    display: grid;
    gap: 3.5px;
    grid-template-columns: 14px minmax(0, 1fr);
}

.tta-section-wrapper.without-label {
    grid-template-columns: minmax(0, 1fr);
}

.tta-section-label {
    align-items: center;
    align-self: start;
    border-radius: 0 14px 14px 0;
    color: var(--color-white);
    display: flex;
    height: 123px;
    justify-content: center;
    margin-top: 132px;
    padding: 5px 0;
    width: 14px;
}

.tta-section-label span {
    color: var(--color-white);
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0;
    transform: rotate(180deg);
    white-space: nowrap;
    writing-mode: vertical-rl;
}

.tta-section-content {
    min-width: 0;
}

.tta-section-toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 5px;
}

.tta-section-toolbar img {
    height: 14px;
}

.tta-section-toolbar .custom-btn {
    font-size: 11px !important;
    min-height: 28px;
    padding-left: 10px;
    padding-right: 10px;
}

.tta-section-toolbar .MuiSwitch-root {
    transform: scale(0.88);
}

.tta-grid {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.tta-card {
    border-radius: 6px;
    padding: 8px 10px 10px;
}

.tta-card-title-row {
    align-items: center;
    display: flex;
    gap: 7px;
    font-size: 10.5px;
    line-height: 1.2;
    min-height: 19px;
}

.tta-card-title-row .table-head-product-buttons {
    font-size: 9.5px;
    font-weight: 500;
}

.tta-sample-size-wrapper {
    flex: 0 0 auto;
    line-height: 1;
}

.tta-sample-size-wrapper > span {
    font-size: 10.5px !important;
    line-height: 1 !important;
}

.tta-sample-size-wrapper .MuiSvgIcon-root {
    font-size: 9.5px !important;
    margin-left: 2px;
    margin-top: -4px;
}

.tta-controls {
    align-items: stretch;
    display: grid;
    gap: 3px;
    grid-template-columns: minmax(0, 1fr) 92px 158px;
    margin: 3px 0 5px;
    min-width: 0;
}

.tta-display-dropdown {
    position: relative;
}

.tta-display-dropdown > button {
    align-items: center;
    background-color: var(--color-white);
    border: var(--table-head-border);
    border-radius: 4px;
    color: var(--light-black);
    display: flex;
    font-size: 10.5px;
    gap: 4.5px;
    height: 100%;
    justify-content: flex-start;
    min-height: 21px;
    overflow: hidden;
    padding: 0 6px;
    text-align: left;
    white-space: nowrap;
    width: 100%;
}

.tta-display-dropdown > button span {
    overflow: hidden;
    text-overflow: ellipsis;
}

.tta-display-dropdown > button span:not(.tta-display-prefix) {
    flex: 1 1 auto;
    min-width: 0;
}

.tta-display-dropdown > button .MuiSvgIcon-root {
    flex: 0 0 auto;
    font-size: 20px;
    margin-left: auto;
    stroke: var(--color-blue);
    stroke-width: 1.6;
}

.tta-dropdown-chevron {
    transition: transform 0.18s ease;
}

.tta-dropdown-chevron.open {
    transform: rotate(180deg);
}

.tta-display-dropdown > button:disabled,
.tta-filter-button.Mui-disabled,
.tta-view-more:disabled {
    cursor: default;
    opacity: 0.45;
    pointer-events: none;
}

.tta-chart-toggle-switch.disabled {
    cursor: default;
    opacity: 0.45;
    pointer-events: none;
}

.tta-display-prefix {
    color: var(--light-grey);
    font-size: 9px;
    font-style: italic;
    opacity: 0.45;
    white-space: nowrap;
}

.tta-display-menu {
    background-color: var(--color-white);
    border: var(--table-head-border);
    box-shadow: var(--table-head-box-shadow);
    left: 0;
    position: absolute;
    top: calc(100% + 2px);
    width: 100%;
    z-index: 7;
}

.tta-display-menu button {
    background-color: var(--color-white);
    border: none;
    color: var(--light-black);
    display: flex;
    font-size: 9.5px;
    gap: 5px;
    padding: 7px 9px;
    text-align: left;
    width: 100%;
}

.tta-filter-wrapper {
    position: relative;
}

.tta-filter-button {
    height: 100%;
    min-width: 100%;
    font-size: 9.5px !important;
    justify-content: center !important;
    min-height: 21px !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
    width: 100% !important;
}

.tta-status-dot {
    align-items: center;
    border-radius: 50%;
    display: inline-flex;
    flex: 0 0 10px;
    height: 10px;
    justify-content: center;
    margin-left: 3.5px;
    width: 10px;
}

.tta-status-dot::after {
    background-color: var(--color-white);
    content: "";
    height: 2px;
    width: 6px;
}

.tta-status-dot.blue {
    background-color: var(--color-blue);
}

.tta-status-dot.red {
    background-color: red;
}

.tta-filter-menu {
    background-color: var(--color-white);
    display: grid;
    grid-template-columns: 48% 52%;
    min-height: 201px;
    position: absolute;
    right: 0;
    top: calc(100% + 4px);
    width: 348px;
    z-index: 8;
}

.tta-filter-categories {
    max-height: 320px;
    overflow-y: auto;
}

.tta-filter-categories button {
    background: transparent;
    border: none;
    border-bottom: 1px solid var(--color-white);
    color: var(--color-white);
    display: block;
    font-size: 9.5px;
    font-weight: 700;
    padding: 9px 14px;
    text-align: left;
    width: 100%;
}

.tta-filter-categories button.active {
    text-decoration: underline;
}

.tta-filter-values {
    display: flex;
    flex-direction: column;
    gap: 7px;
    max-height: 320px;
    overflow-y: auto;
    padding: 9px;
}

.tta-filter-actions {
    align-items: center;
    border-bottom: var(--table-head-border);
    display: flex;
    font-size: 9.5px;
    justify-content: space-between;
    padding-bottom: 5px;
}

.tta-filter-checkbox,
.tta-filter-actions label {
    align-items: center;
    color: var(--light-black);
    display: flex;
    font-size: 9.5px;
    gap: 7px;
}

.tta-apply-button {
    align-self: center;
    border: 1px solid var(--color-blue);
    border-radius: 4px;
    font-size: 12px !important;
    line-height: 1 !important;
    margin-top: auto;
    min-height: 28px !important;
    min-width: 58px;
    padding: 4px 16px !important;
}

.tta-filter-tooltip {
    display: grid;
    gap: 14px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.tta-filter-tooltip p {
    margin: 5px 0 0;
}

.tta-ui-tooltip,
.tta-verbatim-tooltip {
    background-color: var(--color-white) !important;
    border: var(--table-head-border);
    border-radius: 4px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    color: var(--light-black) !important;
    font-size: 9px !important;
    line-height: 1.35 !important;
    max-width: 260px !important;
    padding: 6px 8px !important;
}

.tta-chart-toggle-switch {
    align-items: center;
    background-color: var(--color-white);
    border: 1px solid var(--light-blue);
    border-radius: 4px;
    display: flex;
    flex-wrap: nowrap;
    gap: 0;
    justify-content: center;
    min-height: 21px;
    min-width: 0;
    overflow: hidden;
    position: relative;
    width: 100%;
}

.tta-chart-toggle-switch button {
    background: transparent;
    border: none;
    color: var(--light-black);
    cursor: pointer;
    flex: 1 1;
    font-size: 9.5px;
    font-weight: 500;
    min-height: 19px;
    min-width: 0;
    overflow: hidden;
    padding: 0 3.5px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    z-index: 2;
}

.tta-chart-toggle-switch .MuiSwitch-root {
    flex: 0 0 auto;
    transform: scale(0.82);
}

.tta-chart-toggle-switch button.active {
    color: var(--color-blue);
}

.tta-analysis-frame {
    background-color: var(--color-white);
    column-gap: 8px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 108px;
    min-height: 290px;
}

.tta-analysis-frame.no-verbatim {
    grid-template-columns: 1fr;
}

.tta-chart-area {
    background-color: var(--table-head-background);
    border-right: none;
    min-height: 290px;
    overflow: hidden;
}

.tta-analysis-frame.no-verbatim .tta-chart-area {
    border-right: none;
}

.tta-chart-area.scrollable {
    max-height: 290px;
    overflow: hidden;
}

.tta-bar-chart {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: 25px 38px 32px 20px;
    position: relative;
}

.tta-bar-chart.scrollable {
    max-height: 290px;
    overflow: hidden;
}

.tta-bar-list {
    display: flex;
    flex-direction: column;
    gap: 22px;
}

.tta-bar-chart.scrollable .tta-bar-list {
    margin-right: -34px;
    max-height: 132px;
    overflow-y: auto;
    padding-right: 34px;
    scrollbar-width: thin;
}

.tta-bar-chart.scrollable .tta-bar-list::-webkit-scrollbar {
    width: 4px;
}

.tta-bar-chart.scrollable .tta-bar-list::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
}

.tta-bar-chart.scrollable .tta-bar-list::-webkit-scrollbar-track {
    background: transparent;
}

.tta-bar-row {
    align-items: center;
    display: grid;
    gap: 11px;
    grid-template-columns: 100px minmax(185px, 1fr) 21px;
}

.tta-bar-label {
    font-size: 9px;
    font-weight: 500;
    text-align: right;
}

.tta-bar-track {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 23px;
}

.tta-bar {
    background: #5596ed !important;
    display: inline-block;
    height: 21px;
    width: var(--bar-width);
}

.tta-bar-value {
    font-size: 9.5px;
    font-weight: 500;
}

.tta-chart-footnote {
    bottom: 16px;
    font-size: 9.5px;
    left: 0;
    opacity: 0.75;
    position: absolute;
    text-align: center;
    width: 100%;
}

.tta-web-chart {
    height: 100%;
    width: 100%;
}

.tta-no-data {
    align-items: center;
    color: var(--light-grey);
    display: flex;
    height: 100%;
    justify-content: center;
    text-align: center;
}

.tta-verbatim-panel {
    background-color: var(--table-head-background);
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 290px;
    margin: 0;
    min-height: 0;
    overflow: hidden;
    padding: 10px 8px;
}

.tta-verbatim {
    color: var(--light-black);
    font-size: 8px;
    min-height: 0;
}

.tta-verbatim p {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    font-weight: 500;
    line-clamp: 2;
    margin: 4px 0;
    overflow: hidden;
}

.tta-verbatim strong {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    line-clamp: 2;
    overflow: hidden;
}

.tta-verbatim-icon {
    border-radius: 2px;
    box-sizing: content-box;
    font-size: 16px !important;
    padding: 2px;
}

.tta-verbatim-icon.positive {
    background-color: #d8ffd6;
    color: green;
}

.tta-verbatim-icon.negative {
    background-color: #ffe0e0;
    color: red;
}

.tta-verbatim-icon.mixed {
    height: 20px;
    padding: 0;
    width: 20px;
}

.tta-view-more {
    align-items: center;
    background-color: #e9e9e9;
    border: none;
    border-radius: 4px;
    color: var(--light-black);
    display: flex;
    font-size: 9px;
    gap: 7px;
    justify-content: center;
    margin-top: auto;
    min-height: 24px;
}

.tta-view-more-icon {
    flex: 0 0 auto;
    height: 18px;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2;
    width: 18px;
}

.tta-warning {
    align-items: center;
    display: flex;
    font-size: 9px;
    gap: 5px;
    margin-top: 7px;
    opacity: 0.7;
}

.tta-question {
    font-size: 9px;
    font-weight: 500;
    margin: 6px 0 3px;
}

.tta-summary {
    align-items: flex-start;
    background-color: var(--table-head-background);
    border: var(--table-head-border);
    border-radius: 4px;
    color: var(--light-black);
    display: flex;
    font-size: 9px;
    gap: 9px;
    line-height: 1.35;
    min-height: 34px;
    padding: 5px 8px;
}

.tta-summary-content {
    flex: 1 1;
    min-width: 0;
}

.tta-summary-text {
    display: block;
}

.tta-summary-text.clamped {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    line-clamp: 2;
    overflow: hidden;
}

.tta-summary-toggle {
    font-size: 9px;
    font-weight: 600;
    margin-left: 4px;
}

.tta-summary .MuiSvgIcon-root {
    font-size: 16px !important;
}

.tta-dialog-paper {
    border-radius: 4px !important;
    max-height: 70vh !important;
    max-width: 82vw !important;
    width: 82vw !important;
}

.tta-dialog-title {
    background-color: var(--table-head-background);
    color: var(--color-blue);
    font-size: 14px !important;
    font-weight: 700 !important;
    padding: 18px 44px !important;
    text-align: center;
}

.tta-dialog-close {
    position: absolute !important;
    right: 12px;
    top: 10px;
}

.tta-dialog-content {
    max-height: calc(70vh - 58px);
    overflow-y: auto;
    padding: 34px 58px !important;
}

.tta-modal-grid {
    display: grid;
    gap: 48px;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    padding: 0;
}

.tta-modal-grid strong {
    color: var(--light-black);
    font-size: 13px;
}

.tta-modal-grid p {
    border-bottom: 0;
    color: var(--light-black);
    font-size: 11px;
    line-height: 1.45;
    margin: 22px 0 0;
    padding-bottom: 0;
}

.tta-variable-tabs {
    align-items: flex-end;
    bottom: 28px;
    display: flex;
    left: 0;
    max-width: calc(100% - 32px);
    overflow-x: auto;
    padding-bottom: 6px;
    position: absolute;
}

.tta-variable-tabs::-webkit-scrollbar {
    height: 4px;
}

.tta-variable-tabs::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.18);
    border-radius: 4px;
}

.tta-variable-tabs::-webkit-scrollbar-track {
    background: transparent;
}

.tta-variable-tabs button {
    background: var(--light-blue-gradient-background-2);
    border: var(--table-head-border);
    border-bottom: none;
    clip-path: polygon(0 0, 100% 0, calc(100% - 28px) 100%, 0 100%);
    color: var(--color-white);
    cursor: pointer;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    min-height: 36px;
    min-width: 230px;
    padding: 10px 38px 10px 24px;
}

.tta-variable-tabs button + button {
    clip-path: polygon(28px 0, 100% 0, calc(100% - 28px) 100%, 0 100%);
    margin-left: -28px;
    padding-left: 48px;
}

.tta-variable-tabs button.active {
    background: var(--light-blue-gradient-background);
    color: var(--light-black);
    position: relative;
    z-index: 1;
}

.tta-variable-tabs button span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.text-theme-selection-cell {
    align-items: center;
    display: inline-flex;
    gap: 7px;
    justify-content: center;
}

@media (max-width: 1200px) {
    .tta-grid {
        grid-template-columns: 1fr;
    }

    .tta-controls {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,gHAAgH;IAChH,kHAAkH;IAClH,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;IAChC,wDAAwD,EAAE,4BAA4B;IACtF,uDAAuD;IACvD,6GAA6G;AACjH;AACA;;;IAGI,YAAY;AAChB;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;;;IAII,8DAA8D;AAClE;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;IAChC,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,iBAAiB;AACjB;IACI,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,eAAe;IACf,wBAAwB;IACxB,gCAAgC;IAChC,2BAA2B;IAC3B,yGAAyG;AAC7G;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,wBAAwB;IACxB,sBAAsB;IACtB,yBAAyB;IACzB,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA,YAAY;AACZ;IACI,qBAAqB;IACrB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA,8CAA8C;;AAE9C;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,UAAU;IACV,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,qCAAqC;AACzC;;AAEA;IACI;QACI,yCAAyC;IAC7C;;IAEA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;IACI;QACI,uDAAuD;IAC3D;;IAEA;QACI,wDAAwD;IAC5D;AACJ;;AAEA;IACI,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;IACI;QACI,yDAAyD;IAC7D;;IAEA;QACI,wDAAwD;IAC5D;AACJ;;AAEA;IACI,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;IACI;QACI,yCAAyC;IAC7C;;IAEA;QACI,yCAAyC;IAC7C;AACJ;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,4DAA4D;IAC5D,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,UAAU;IACV,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA,uDAAuD;AACvD,mEAAmE;;AAEnE,mDAAmD;AACnD;AACA;;AAEA,2CAA2C;AAC3C;AACA;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA,2CAA2C;AAC3C;AACA;;AAEA,oDAAoD;AACpD;AACA;;AAEA,sDAAsD;AACtD;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,sDAAsD;AACtD;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,gBAAgB;AAChB;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,sBAAsB;IACtB,+CAA+C;IAC/C,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;IAErC,sBAAsB;IAEtB,kBAAkB;AACtB;;AAEA;IACI,yDAAm5B;IACn5B,mCAAmC;IACnC,+BAA+B;IAE/B,mDAAyS;AAC7S;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,sBAAsB;IACtB,6BAA6B;IAC7B;;8CAE0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;IACI,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,mCAAmC;IACnC,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,iDAAiD;AACrD;AACA;IACI,mDAAmD;AACvD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,wCAAwC;AAC5C;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,2BAA2B;IAC3B,kBAAkB;IAClB,wCAAwC;IACxC;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,8CAA8C;IAC9C,kBAAkB;IAClB,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wCAAwC;IACxC,wCAAwC;IACxC,mBAAmB;IACnB,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,0FAA0F;AAC9F;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,+BAA+B;AACnC;AACA;IACI,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,cAAc;IACd,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4CAA4C;AAChD;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,UAAU;IACV,0CAA0C;AAC9C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;IAC5B,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,QAAQ;IACR,gDAAgD;IAChD,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,gCAAgC;IAChC,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,eAAe;IACf,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,wCAAwC;IACxC,OAAO;IACP,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,kCAAkC;IAClC,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,2CAA2C;IAC3C,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gDAAgD;AACpD;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,+CAA+C;IAC/C,gCAAgC;IAChC,6BAA6B;IAC7B,yCAAyC;IACzC,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,MAAM;IACN,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,SAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,aAAa;IACb,2CAA2C;IAC3C,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,oDAAoD;AACxD;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,8CAA8C;IAC9C,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,QAAQ;IACR,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,QAAQ;IACR,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,8CAA8C;IAC9C,gCAAgC;IAChC,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,8CAA8C;IAC9C,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,2DAA2D;IAC3D,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,OAAO;IACP,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mDAAmD;IACnD,gCAAgC;IAChC,mBAAmB;IACnB,+DAA+D;IAC/D,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kEAAkE;IAClE,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iDAAiD;IACjD,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[":root {\n    --light-blue: #47c8ff;\n    --light-black: #2d2d2d;\n    --light-grey: #2d2d2d;\n    --light-blue-gradient-background: linear-gradient(90deg, rgba(71, 163, 255, 0.999) 0%, rgba(0, 94, 239, 1) 100%);\n    --light-blue-gradient-background-2: linear-gradient(90deg, rgba(191, 242, 255, 1) 0%, rgba(195, 215, 255, 1) 100%);\n    --color-white: #fff;\n    --color-blue: #005eef;\n    --table-head-background: #f0f8ff;\n    --table-head-border: 0.5px solid rgba(71, 200, 255, 0.9); /* Stroke with 90% opacity */\n    --table-head-box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\n    --table-body-cell-background: linear-gradient(180deg, rgba(217, 247, 255, 1) 0%, rgba(195, 215, 255, 1) 100%);\n}\ntable,\ntr,\ntd {\n    height: 100%;\n}\n.color-white {\n    color: var(--color-white) !important;\n}\n\n.color-blue {\n    color: var(--color-blue) !important;\n}\n\n.color-black {\n    color: var(--light-black) !important;\n}\n\n.color-disabled {\n    color: var(--light-grey) !important;\n}\n\n.white-background {\n    background: #fff;\n}\n\n.b {\n    border: 1px solid red;\n}\n\n.b2 {\n    border: 1px solid green;\n}\n\n.b3 {\n    border: 1px solid rgb(21, 0, 128);\n}\n\n.header-container {\n    min-height: 65px;\n}\n\n.brand-logo--header {\n    height: 40px;\n    width: 40px;\n    filter: brightness(0) invert(1);\n}\n\n.header-icons-container {\n    float: right;\n    z-index: 3;\n}\n\n.header-icons-container span {\n    cursor: pointer;\n}\n\n.header-logo-container {\n    display: flex;\n    justify-items: center;\n}\n\n.vl {\n    border-left: 1px solid #fff;\n    height: 38px;\n    margin-top: 2px;\n    width: 0px;\n    margin-left: 5px;\n}\n\n.vl-2 {\n    border-left: 2px solid #49505772;\n    height: auto;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    width: 0px;\n}\n\n.full-container {\n    border-radius: 10px;\n}\n\n.full-container m-4 {\n    max-height: 100%;\n    border-radius: 10px;\n}\n\n.dropdown-card {\n    min-height: 145px;\n    border-radius: 0px 0px 5px 5px;\n    margin: 0px auto;\n    font-size: 12px;\n    background-color: #fff;\n}\n\n.card-btns {\n    display: flex;\n    justify-content: space-between;\n}\n\n.disabled-btn {\n    background-color: grey !important;\n    color: #fff !important;\n}\n\n.disabled {\n    cursor: default !important;\n    pointer-events: none !important;\n    color: grey;\n}\n\n.dropdown-card-image {\n    height: 100px;\n    width: 100%;\n}\n\n.dropdown-cards-image-container {\n    padding: 5px 5px 0px 5px;\n}\n\n.dropdown-card-dropdown-container {\n    padding: 5px;\n}\n\n.dropdown-first-row {\n    z-index: 5 !important;\n}\n\n.dropdown-correlation {\n    width: 450px !important;\n    border-radius: 0px 0px 5px 5px;\n    margin: 0px auto;\n    font-size: 12px;\n    background-color: #fff;\n}\n\n.dropdown-driver-analysis {\n    border-radius: 0px 0px 5px 5px;\n    margin-left: 28px;\n    font-size: 12px;\n    background-color: #fff;\n}\n\n.dropdown-cards-image-container > button,\n.dropdown-card > .dropdown-card-dropdown-container > .dropdown > div,\n.dropdown-card-dropdown-container > input,\n.dropdown-card > .dropdown-card-dropdown-container > .custom-file > label {\n    background: var(--light-blue-gradient-background-2) !important;\n}\n\n.dialogue-input-label-container {\n    margin: 5px 0px 10px 0px;\n}\n\n.dialogue-dropdown > .css-13cymwt-control,\n.dialogue-dropdown > .css-t3ipsp-control {\n    min-height: unset !important;\n}\n\n.dialogue-dropdown > div > .css-1hb7zxy-IndicatorsContainer > .css-1xc3v61-indicatorContainer,\n.dialogue-dropdown > div > .css-1hb7zxy-IndicatorsContainer > .css-15lsz6c-indicatorContainer {\n    padding: 12px 0px;\n}\n\n.dropdown > .css-1nmdiq5-menu {\n    z-index: 2 !important;\n}\n\n:where(.css-dev-only-do-not-override-1jr9qlj).ant-picker-dropdown {\n    z-index: 10999999 !important;\n}\n\n.ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel .ant-picker-content,\n:where(.css-dev-only-do-not-override-1jr9qlj).ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel table {\n    height: 24px;\n}\n\n.date-picker-pop-up-calendar {\n    z-index: 100000;\n}\n\n.multi-select-dropdowns > .css-13cymwt-control > .css-3w2yfm-ValueContainer {\n    display: flex;\n    flex-direction: row;\n    overflow-y: scroll;\n    overflow-x: scroll;\n    height: 100%;\n}\n\n.multi-select-dropdowns > .css-13cymwt-control > .css-3w2yfm-ValueContainer .css-1p3m7a8-multiValue {\n    min-width: unset;\n}\n\n.tabs-container > div > div {\n    margin-top: 10px;\n    background-color: #eee;\n    display: inline-block;\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.search-bar-input:focus {\n    outline: none;\n    border: 1px solid var(--color-blue);\n}\n\n.search-bar-input {\n    outline: none;\n    border: 1px solid var(--color-blue);\n    border-radius: 3px 0px 0px 3px;\n}\n\n.css-1betqn-MuiAccordionSummary-content {\n    margin: 0px !important;\n}\n\n.tab-labels {\n    text-transform: unset !important;\n    background-color: #eee;\n    padding: 10px 20px !important;\n    min-height: unset !important;\n    font-size: 14px !important;\n}\n\n.tab-labels svg {\n    font-size: 1rem;\n}\n\n.footer {\n    height: 38px;\n}\n\n.tab--edit-button {\n    display: block;\n}\n\n.tab--edit-button button {\n    right: 0;\n}\n\n.error-404--container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -ms-transform: translateY(-50%);\n    -ms-transform: translateX(50%);\n}\n\n.error-404--container h1 {\n    color: #4d4d4d;\n    letter-spacing: 4px;\n}\n\n.error-404--container img {\n    width: 500px;\n}\n\n.page-name--title {\n    text-transform: uppercase;\n}\n\n.header-title-suffix {\n    font-size: 0.75rem;\n    font-weight: 400;\n    letter-spacing: 0.4px;\n    margin-left: 6px;\n    opacity: 0.85;\n    text-transform: none;\n}\n\n.tabs-toggle div div .tab-labels {\n    background-color: #eee;\n    border-radius: 4px;\n    padding: 0.55rem !important;\n}\n\n.tabs-toggle div div .tab-labels.Mui-selected {\n    color: #fff;\n    background: var(--light-blue-gradient-background) !important;\n}\n\n.outlined-vtn-container--data-seeding {\n    position: relative;\n    right: calc(-100% + 55px);\n    display: inline;\n    top: -62px;\n}\n\n.text-input {\n    width: 100%;\n    height: 29px;\n    border-radius: 4px;\n    border: none;\n    border-style: solid;\n    border-width: 1px;\n    outline-color: var(--color-blue);\n    border-color: hsl(0, 0%, 80%);\n    font-weight: 400;\n    font-size: 10px;\n    line-height: 1.5;\n    letter-spacing: 0.00938em;\n    padding: 0px 10px;\n}\n\n.text-input:focus {\n    border: 1px solid var(--color-blue);\n    outline: 1px solid var(--color-blue);\n}\n\n.custom-btn-outlined > span > svg {\n    font-size: 15px !important;\n}\n\n.horizontal-menu {\n    display: flex;\n}\n\n.menu-list {\n    display: flex !important;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.menu-list a {\n    color: inherit;\n    text-decoration: none;\n}\n\n.edit--dialogue > div {\n    margin: 20px 30px;\n}\n\n.input-label-dialog {\n    color: #424242d4 !important;\n    font-size: 13px !important;\n    padding-bottom: 5px !important;\n    font-weight: 600 !important;\n}\n\n.text-input-dialog {\n    width: 100%;\n    border-radius: 4px;\n    border: none;\n    border-style: solid;\n    border-width: 1px;\n    outline-color: var(--color-blue);\n    border-color: hsl(0, 0%, 80%);\n    outline: none;\n    font-weight: 400;\n    letter-spacing: 0.00938em;\n    padding: 7px 10px;\n}\n\n.text-input-dialog:focus {\n    border: 1px solid var(--color-blue);\n    outline: 1px solid var(--color-blue);\n}\n\n.dropdown-dialog .css-13cymwt-control > .css-1fdsijx-ValueContainer > .css-1dimb5e-singleValue,\n.dropdown-dialog .css-13cymwt-control > .css-1fdsijx-ValueContainer > .css-qbdosj-I.nput > input {\n    color: var(--color-blue) !important;\n}\n\n.month-year--picker,\n.month-year--picker:hover {\n    padding: 0px 10px;\n    width: 100%;\n    height: 31.6px;\n    border-radius: 4px;\n    border: none;\n    border-style: solid;\n    border-width: 1px;\n    outline: none;\n    border-color: hsl(0, 0%, 80%);\n}\n\n.month-year--picker > .ant-picker-input > input {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: 0.00938em;\n}\n\n.month-year--picker > .ant-picker-input > input::placeholder {\n    font-size: 12px;\n    color: hsl(0, 0%, 50%);\n}\n\n.ant-picker-dropdown {\n    z-index: 9999 !important;\n}\n\n/* badge drawer */\n.badge-drawer-button {\n    min-height: min-content;\n    position: sticky;\n    top: 120px;\n    float: right;\n    clear: both;\n    display: inline;\n    padding: 7px 7px 7px 2px;\n    border-radius: 20px 0px 0px 20px;\n    background: rgb(0, 94, 239);\n    background: linear-gradient(90deg, rgba(0, 94, 239, 0.11668417366946782) 0%, rgba(209, 209, 209, 1) 100%);\n}\n\n.badge-drawer-button > span {\n    min-height: max-content;\n    color: #fff;\n    height: auto !important;\n    background-color: var(--color-blue);\n    padding: 7px 7px;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.badge-drawer-button > span > .css-i4bv87-MuiSvgIcon-root {\n    height: auto !important;\n}\n\n/* landing page */\n.landing-page-table > div > table > thead > tr > th > div > svg {\n    font-size: 20px;\n    margin-top: 10px;\n}\n\n.landing-page-table > div > table > thead > tr > th > div > p {\n    font-size: 12px;\n    margin-top: 10px;\n    margin-bottom: 5px;\n}\n\n.landing-page-table > div > table {\n    min-height: calc(100vh - 260px);\n    max-height: calc(100vh - 260px);\n    height: calc(100vh - 260px);\n    margin-bottom: 0px;\n}\n\n.compare-labels-container {\n    display: flex;\n    justify-content: space-around;\n    height: auto;\n}\n\n.compare-labels-container > div {\n    display: flex;\n    align-items: center;\n    max-width: 300px;\n}\n\n.compare-labels-container > div > p {\n    margin-bottom: 0px;\n    color: #4d4d4d;\n    letter-spacing: 0.8px;\n}\n\nul.dialog-list {\n    list-style: none;\n    padding-left: 20px;\n}\n\nul.dialog-list li {\n    margin-top: 20px;\n}\n\n.dialog-list-icon {\n    color: var(--color-blue);\n    font-size: 20px;\n    margin-right: 10px;\n}\n\n.dialog-errorMessage {\n    background-color: #d2d2d2;\n    padding: 10px 40px;\n}\n\n.upload-container {\n    display: flex;\n    margin: 20px 0px;\n}\n\n.custom-file--W-400 {\n    width: 400px !important;\n}\n\n.custom-file {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    height: 28px;\n    margin-bottom: 0;\n}\n\n.custom-file-input {\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    height: 28px;\n    margin: 0;\n    overflow: hidden;\n    opacity: 0;\n    cursor: pointer;\n}\n\n.custom-file-label {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1;\n    height: 28px;\n    padding: 0.375rem 0.75rem;\n    font-weight: 400;\n    line-height: 1.6;\n    color: #495057;\n    background-color: #fff;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    width: 100%;\n    overflow: hidden;\n    font-size: 10px;\n}\n\n.custom-file-label::after {\n    letter-spacing: 0.5px;\n    font-weight: 500;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: 28px;\n    padding: 0.6rem 0.75rem;\n    line-height: 1;\n    color: var(--color-blue);\n    content: \"Browse File\";\n    background-color: #e9ecef;\n    border-left: inherit;\n    border-radius: 0 0.25rem 0.25rem 0;\n}\n\n/* filters */\n.remove-opacity {\n    opacity: 1 !important;\n    transform: scale(1.1);\n    pointer-events: unset !important;\n}\n\n.enable-filter {\n    opacity: 0.8 !important;\n    pointer-events: unset !important;\n}\n\n.filter-key-box > button {\n    opacity: 0.4;\n    margin: 10px auto 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: ease-out 0.1s;\n    pointer-events: none;\n    border: none;\n    outline: none;\n}\n\n.filter-key-box > button > span {\n    font-weight: 600;\n    padding-top: 5px;\n}\n\n.filter-img-box {\n    overflow: hidden;\n    border-radius: 5px 5px;\n}\n\n.filter-img-box img {\n    height: 70px;\n    width: 100px;\n}\n\n/* input labels and container product details*/\n\n.product-details-input-labels-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 10px 0px 20px 0px;\n}\n\n.product-details-input-labels-container label {\n    color: #424242d4 !important;\n    font-size: 13px !important;\n    font-weight: 600 !important;\n}\n\n.product-details-input-labels-container input {\n    color: #424242d4 !important;\n    font-size: 13px !important;\n    width: 70%;\n    outline: none;\n    padding: 1px 10px;\n    border: 1px solid #49505772;\n    border-radius: 3px;\n}\n\n.product-details-input-labels-container p {\n    color: #424242d4 !important;\n    font-size: 13px !important;\n    width: 70%;\n    padding: 1px 10px;\n    border: 1px solid #49505772;\n    border-radius: 3px;\n    min-height: 25px;\n    margin-top: 0;\n    margin-bottom: 0;\n    text-wrap: wrap;\n    word-break: break-all;\n}\n\n.product-details-input-labels-container a {\n    font-size: 13px !important;\n    width: 70%;\n    outline: none;\n    padding: 1px 10px;\n    border: 1px solid #49505772;\n    border-radius: 3px;\n    word-break: break-all;\n}\n\n.product-details-label {\n    width: 150px;\n}\n\n/* loader*/\n.loader-container {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    /* background-color: rgba(0, 0, 0, 0.5); */\n    z-index: 2;\n}\n\n#page {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n#container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n#h3 {\n    /* color: white; */\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 1px;\n}\n\n#ring {\n    width: 190px;\n    height: 190px;\n    border: 1px solid transparent;\n    border-radius: 50%;\n    position: absolute;\n}\n\n#ring:nth-child(1) {\n    border-bottom: 8px solid rgb(255, 141, 249);\n    animation: rotate1 2s linear infinite;\n}\n\n@keyframes rotate1 {\n    from {\n        transform: rotateX(50deg) rotateZ(110deg);\n    }\n\n    to {\n        transform: rotateX(50deg) rotateZ(470deg);\n    }\n}\n\n#ring:nth-child(2) {\n    border-bottom: 8px solid rgb(255, 65, 106);\n    animation: rotate2 2s linear infinite;\n}\n\n@keyframes rotate2 {\n    from {\n        transform: rotateX(20deg) rotateY(50deg) rotateZ(20deg);\n    }\n\n    to {\n        transform: rotateX(20deg) rotateY(50deg) rotateZ(380deg);\n    }\n}\n\n#ring:nth-child(3) {\n    border-bottom: 8px solid var(--color-blue);\n    animation: rotate3 2s linear infinite;\n}\n\n@keyframes rotate3 {\n    from {\n        transform: rotateX(40deg) rotateY(130deg) rotateZ(450deg);\n    }\n\n    to {\n        transform: rotateX(40deg) rotateY(130deg) rotateZ(90deg);\n    }\n}\n\n#ring:nth-child(4) {\n    border-bottom: 8px solid rgb(252, 183, 55);\n    animation: rotate4 2s linear infinite;\n}\n\n@keyframes rotate4 {\n    from {\n        transform: rotateX(70deg) rotateZ(270deg);\n    }\n\n    to {\n        transform: rotateX(70deg) rotateZ(630deg);\n    }\n}\n\n/*t-test dialog css */\n.test-type {\n    background-color: #ffffff;\n    border: 1px solid #335eea;\n    border-radius: 4px;\n    padding: 5px 0px;\n    text-align: center;\n    font-size: 14px;\n}\n\n.test-type-selected {\n    background: var(--light-blue-gradient-background) !important;\n    color: #ffffff;\n}\n\n.test-type-disabled {\n    border: 1px solid #cccccc;\n    color: #969696;\n}\n\n.radio-label {\n    max-width: 25ch;\n    margin-top: 8px;\n}\n\n.overall-table-column-hidden {\n    color: transparent !important;\n    font-size: 0px !important;\n    padding: 0;\n    max-width: 30px !important;\n    white-space: nowrap !important;\n}\n\n.overall-table-sticky-row1 {\n    position: sticky;\n    left: 150px;\n}\n\n.overall-table-sticky-row2 {\n    position: sticky;\n    left: 450px;\n    white-space: nowrap;\n    overflow: visible;\n}\n\n.overall-table-sticky-row2-container {\n    position: relative;\n}\n\n.overall-table-sticky-row2-content {\n    position: stick;\n    background-color: red;\n    white-space: normal;\n    overflow: visible;\n    z-index: 1;\n    min-width: 200px;\n    /* Set a minimum width for the cell */\n}\n\n.overall-kip-tab > div {\n    padding-top: 0px !important;\n}\n\n.ag-multi-line-cell-render span {\n    display: block !important;\n    padding: 0;\n}\n\n.ag-multi-line-cell-render p {\n    line-height: 15px;\n}\n\n.ag-multi-line-cell-render :not(:first-child) {\n    margin-top: -10px;\n}\n\n.ag-multi-line-cell-render :nth-child(1) {\n    margin-top: 5px;\n}\n\n.move-button--hidden {\n    transform: translate(0px, 100px);\n    transition: ease-out 0.5s;\n}\n\n.move-button--visible {\n    transform: translate(0px, 0px);\n    transition: ease-out 0.5s;\n}\n\n/* X-Small devices (portrait phones, less than 576px) */\n/* No media query for `xs` since this is the default in Bootstrap */\n\n/* Small devices (landscape phones, 576px and up) */\n@media (min-width: 576px) {\n}\n\n/* Medium devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n}\n\n@media (max-width: 768px) {\n    .outlined-vtn-container--data-seeding {\n        display: block;\n        position: unset;\n        right: unset;\n        top: unset;\n    }\n}\n\n/* Large devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n}\n\n/* X-Large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) {\n}\n\n/* XX-Large devices (larger desktops, 1400px and up) */\n@media (min-width: 1400px) {\n    .dropdown-card-image {\n        min-height: 150px;\n    }\n\n    .dropdown-card {\n        min-height: 195px;\n    }\n}\n\n@media (min-width: 1920px) {\n    .dropdown-card-image {\n        min-height: 170px;\n    }\n\n    .dropdown-card {\n        min-height: 215px;\n    }\n}\n\n/* XX-Large devices (larger desktops, 1400px and up) */\n@media (min-width: 2560px) {\n    .dropdown-card-image {\n        min-height: 190px;\n    }\n\n    .dropdown-card {\n        min-height: 225px;\n    }\n}\n\n/*Tooltip style*/\n.fixed-height-tooltip {\n    max-height: 42vh !important;\n    overflow-y: auto;\n    width: 25vw !important;\n    border: rgb(222, 226, 230) solid 2px !important;\n    border-radius: 5px !important;\n}\n\n::-webkit-scrollbar {\n    width: 8px;\n    height: 10px;\n    background-color: #ffffff;\n    border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb {\n    border-radius: 5px;\n    background: #c2c9d2;\n}\n\n.custom_checkbox__input {\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n}\n\n.custom_checkbox__label {\n    font-weight: 600;\n    position: relative;\n    padding-left: 28px;\n}\n\n.custom_checkbox__label:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 18px;\n    height: 18px;\n    border: 2px rgba(0, 0, 0, 0.54) solid;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    -webkit-border-radius: 3px;\n    border-radius: 3px;\n}\n\n.custom_checkbox__input:checked ~ .custom_checkbox__label:before {\n    background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8cGF0aAogICAgIGQ9Ik0gMC4wNDAzODA1OSwwLjYyNjc3NjcgMC4xNDY0NDY2MSwwLjUyMDcxMDY4IDAuNDI5Mjg5MzIsMC44MDM1NTMzOSAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IE0gMC4yMTcxNTcyOSwwLjgwMzU1MzM5IDAuODUzNTUzMzksMC4xNjcxNTcyOSAwLjk1OTYxOTQxLDAuMjczMjIzMyAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IgogICAgIGlkPSJyZWN0Mzc4MCIKICAgICBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpub25lIiAvPgo8L3N2Zz4K\");\n    background-color: var(--color-blue);\n    border-color: var(--color-blue);\n    -webkit-mask-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxIDEiPjx0aXRsZT51bnRpdGxlZDwvdGl0bGU+PHBhdGggZD0iTTAsMFYxSDFWMEgwWk0wLjQ1LDAuNzRsLTAuMDguMDhMMC4yOCwwLjc0LDAuMTQsMC42bDAuMDgtLjA4TDAuMzYsMC42NWwwLjQxLS40MUwwLjg2LDAuMzJaIi8+PC9zdmc+\");\n    mask-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxIDEiPjx0aXRsZT51bnRpdGxlZDwvdGl0bGU+PHBhdGggZD0iTTAsMFYxSDFWMEgwWk0wLjQ1LDAuNzRsLTAuMDguMDhMMC4yOCwwLjc0LDAuMTQsMC42bDAuMDgtLjA4TDAuMzYsMC42NWwwLjQxLS40MUwwLjg2LDAuMzJaIi8+PC9zdmc+\");\n}\n\n.custom_checkbox__input[type=\"checkbox\"]:disabled + label::before {\n    background: #bdbdbd;\n    border-color: #a1a1a1;\n}\n\n.custom_checkbox__input ~ .custom_checkbox__label:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.custom_checkbox__input:checked ~ .custom_checkbox__label:after {\n    background-color: var(--color-blue);\n}\n\n.input_border_color {\n    border: 0.5px solid var(--color-blue);\n    border-radius: 5px;\n}\n\n.input_border_color:focus {\n    border-color: var(--color-blue);\n    outline: none;\n}\n\n.missing-filters-tooltip {\n    max-height: 42vh !important;\n    overflow-y: auto;\n    width: 100% !important;\n    border-radius: 5px !important;\n    box-shadow:\n        rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,\n        rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n}\n\n.missing-filters-ul {\n    font-size: 0.75rem;\n    line-height: 23px;\n    padding-left: 25px;\n}\n\n.missing-filters-ul li::marker {\n    font-size: 7px;\n}\n\n.invert {\n    filter: opacity(0.1);\n}\n\n.highlight {\n    background-color: yellow;\n    /* Highlight background */\n}\n\n/* style for action standard tabs */\n.tab-system {\n    width: 100%;\n    margin: 0 auto;\n    border-radius: 5px;\n    padding: 10px;\n}\n\n.tab-nav {\n    display: flex;\n    margin-bottom: 10px;\n    border-bottom: 1px solid gray;\n}\n\n.tab-item {\n    padding: 5px 10px;\n    display: flex;\n    align-items: center;\n    background-color: #f1f1f1;\n    border: 1px solid gray;\n    border-bottom: none;\n}\n\n.tab-item.active {\n    background-color: #ffffff;\n    border: 1px solid gray;\n    border-bottom: none;\n}\n\n.tab-item button {\n    background: none;\n    border: none;\n    margin-left: 5px;\n}\n\n.close-btn {\n    color: red;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.add-btn {\n    color: rgb(51, 94, 234);\n    padding: 5px 10px;\n    cursor: pointer;\n    background-color: #ffffff;\n    border: 1px solid gray;\n    border-bottom: none;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.disable-add-btn {\n    color: #989898;\n    padding: 5px 10px;\n    cursor: pointer;\n    background-color: #e8e8e8;\n    border: 1px solid #a8a8a8;\n    border-bottom: none;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.tab-content {\n    padding: 10px;\n    border-radius: 5px;\n}\n\n/* style for action standard form */\n.as-input-label {\n    padding-top: 5px;\n    margin-right: 5px;\n    width: 37%;\n}\n\n.as-input-field {\n    margin-right: 5px;\n    width: 62%;\n}\n\n.as-input-container {\n    display: flex;\n    margin: 10px;\n}\n\n.as-kpi-label {\n    width: 99%;\n    background-color: #e8e8e8;\n    font-weight: 700;\n    text-align: center;\n    height: 30px;\n    padding: 5px;\n}\n\n.as-kpi-button {\n    width: 99%;\n    background-color: #00ff00;\n    border: 1px solid #00ff00;\n    font-weight: 700;\n    text-align: center;\n    height: 30px;\n    color: #fff;\n    margin-top: 10px;\n}\n\n.as-kpi-header {\n    width: 90%;\n    font-weight: 700;\n    text-align: center;\n    padding: 5px;\n    margin: 20px;\n}\n\n.kpi-add-btn {\n    border-radius: 50%;\n    background-color: rgb(0, 255, 0);\n    padding: 3px 8px;\n    border: 1px solid rgb(0, 255, 0);\n    color: rgb(255, 255, 255);\n    font-weight: bold;\n}\n\n.kpi-remove-btn {\n    border-radius: 50%;\n    background-color: rgb(255, 0, 0);\n    padding: 3px 8px;\n    border: 1px solid rgb(255, 0, 0);\n    color: rgb(255, 255, 255);\n    font-weight: bold;\n    margin: 0px 10px;\n}\n\n.condition-block {\n    position: relative;\n}\n\n.condition-block .condition-remove-btn {\n    position: absolute;\n    top: -10px;\n    right: -10px;\n    padding: 2px 8px;\n    border-radius: 50%;\n    background-color: red;\n    color: white;\n}\n\n.as-textarea {\n    border: 1px solid hsl(0, 0%, 80%);\n    border-radius: 4px;\n    background-color: rgba(239, 239, 239, 0.3);\n    padding: 5px;\n    width: 100%;\n    min-height: 70px;\n}\n\n.input-label {\n    display: block;\n    color: rgb(48, 48, 48);\n}\n\n.input-label-select {\n    display: block;\n    max-width: 100%;\n    min-height: 40px;\n    width: 100%;\n    border-radius: 5px;\n    outline: none;\n    color: rgb(48, 48, 48);\n    transition-duration: 0.2s;\n}\n\n.input-label-field {\n    display: block;\n    max-width: 100%;\n    height: 35px;\n    width: 100%;\n    border-radius: 5px;\n    border: 1px solid #dddddd;\n    padding: 0px 12px;\n    outline: none;\n    caret-color: var(--color-blue);\n    color: rgb(48, 48, 48);\n    transition-duration: 0.2s;\n}\n\n.input-label-field-width-500 {\n    min-width: 500px;\n}\n\n.input-label-select:focus {\n    border: 2px solid var(--color-blue);\n    transition-duration: 0.2s;\n}\n\n.input-label-field:focus {\n    border: 2px solid var(--color-blue);\n    transition-duration: 0.2s;\n}\n\nlabel.button,\n.button {\n    cursor: pointer;\n}\n\n.boxed label {\n    display: inline-block;\n    margin: 20px;\n    width: 240px;\n    padding: 7px 7px 5px;\n    border: solid 4px var(--color-blue);\n    transition: all 0.4s;\n    border-radius: 10px;\n    text-align: center;\n    font-size: 18px;\n    color: var(--color-blue);\n}\n\n.boxed input[type=\"radio\"] {\n    display: none;\n}\n\n.boxed input[type=\"radio\"]:checked + label {\n    background: var(--light-blue-gradient-background);\n    color: var(--color-white);\n}\n\n.button-confirm {\n    background-color: #00a6c9;\n    border-color: transparent;\n    padding: 10px 100px;\n    color: #ffffff;\n    background: #333;\n    border-radius: 5px;\n    border: 1px solid #fff;\n}\n\n.liner-light-blue-background {\n    background: var(--light-blue);\n    background: var(--light-blue-gradient-background);\n}\n.liner-light-blue-background-2 {\n    background: var(--light-blue-gradient-background-2);\n}\n\n.css-byenzh-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked {\n    color: #47c8ff !important;\n}\n\n.custom-btn-outlined-2 {\n    color: var(--color-blue) !important;\n    border-color: var(--light-blue) !important;\n}\n\n.image-white {\n    filter: brightness(0) invert(1);\n}\n\n.custom-btn-outlined-3 {\n    border-color: var(--light-blue) !important;\n}\n\n.table-chart-toggle-container {\n    border-radius: 5px;\n    border: 1px solid var(--light-blue);\n    font-size: 12px;\n    display: flex;\n    padding: 1px;\n}\n\n.table-chart-toggle-container div {\n    border-radius: 3px;\n    padding: 3px 5px;\n    cursor: pointer;\n    width: 50%;\n    text-align: center;\n}\n\n.table-seperator-row-height {\n    height: 30px;\n}\n.table-seperator-head-height {\n    height: 50px;\n}\n\n.table-seperator-blue {\n    border-radius: 10px;\n    width: 7px;\n    background-color: #0060ef9e;\n    position: relative;\n    left: -7px;\n    box-shadow: var(--table-head-box-shadow);\n}\n.table-seperator-col {\n    border-radius: 10px;\n    width: 7px;\n    background-color: #0060ef9e;\n    margin-right: 10px;\n    box-shadow: var(--table-head-box-shadow);\n    margin-left: -6px\n}\n\n.table-seperator-col-hair-skin {\n    background-color: #619CF5;\n}\n\n.table-seperator-grey {\n    border-radius: 10px;\n    width: 7px;\n    background-color: var(--table-head-background);\n    position: relative;\n    left: -7px;\n    box-shadow: var(--table-head-box-shadow);\n}\n \n.table-seperator-grey-hair-skin {\n    background-color: #619CF5;\n}\n.analysis-table > :not(caption) > * > * {\n    border-bottom-width: 0px;\n}\n\n.analysis-table th > div > .table-head-cell {\n    background: var(--table-head-background);\n    box-shadow: var(--table-head-box-shadow);\n    border-radius: 10px;\n    color: var(--color-blue);\n    height: 100%;\n    width: 100%;\n    padding: 5px;\n}\n\n.analysis-table td > div > .table-body-cell {\n    color: #000;\n    height: 100%;\n    width: 100%;\n}\n\n.bold-content {\n    font-weight: bold !important;\n    letter-spacing: 0.4px !important;\n}\n\n.custom-btn--upload-reset.Mui-disabled {\n    color: rgba(0, 0, 0, 0.6) !important;\n}\n\n.no-break {\n    white-space: nowrap;\n}\n\n.gap {\n    height: 15px;\n    border-color: #ffffff;\n}\n\n.disabled-input {\n    color: #999999;\n}\n\n.itm-td {\n    transform: scale(0.8);\n    animation: fadeInScale 1s ease-out forwards;\n}\n\n@keyframes fadeInScale {\n    0% {\n        opacity: 0;\n        transform: scale(0.8);\n    }\n    50% {\n        opacity: 1;\n        transform: scale(1.05);\n    }\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n.weighted-span {\n    transform: scale(0.8);\n    animation: fadeWeightedScale 1s ease-out forwards;\n}\n\n.score-span {\n    background-color: #ffffffff;\n}\n\n@keyframes fadeWeightedScale {\n    0% {\n        opacity: 0;\n        transform: scale(0.8);\n    }\n    50% {\n        opacity: 1;\n        transform: scale(1.05);\n    }\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n.custom-swal-popup .swal2-html-container {\n    font-size: 14px;\n    line-height: 1.2;\n    padding: 5px;\n}\n\n.custom-swal-popup .swal-text {\n    margin: 5px;\n}\n\n.custom-swal-popup .swal2-actions {\n    margin: 5px;\n}\n\n.custom-swal-popup .swal2-styled {\n    margin: 5px;\n    font-size: 12px;\n    background: linear-gradient(90deg, rgba(71, 163, 255, 0.999) 0%, rgba(0, 94, 239, 1) 100%);\n}\n.swal2-container {\n    z-index: 10000 !important;\n}\n\n.cp-tab-labels {\n    text-transform: unset !important;\n    font-weight: 600 !important;\n}\n\n.stm-form-group {\n    margin-bottom: 16px;\n    margin-top: 20px;\n}\n\n.stm-form-group label {\n    display: inline-flex;\n    margin-bottom: 6px;\n    color: #333;\n    width: 32%;\n    font-size: 11px;\n}\n\n.stm-form-group input,\n.stm-form-group select {\n    width: 66%;\n    padding: 10px;\n    border-radius: 6px;\n    border: none;\n    background-color: #faf7f7;\n    display: inline-flex;\n    margin-left: 10px;\n    font-size: 11px;\n}\n\n.stm-form-group input:focus {\n    outline: 1px solid var(--color-blue);\n}\n\n.table-head-product-buttons {\n    background: none;\n    color: var(--color-blue);\n    text-align: center;\n    font-weight: 600;\n    border: none;\n}\n.clean-button {\n    outline: none;\n    border: none;\n    background: none;\n}\n\n.sign-in-box {\n    background-color: #ededed;\n    margin-top: 40px;\n    text-align: center;\n}\n.sign-in-box-shadow {\n    box-shadow: 0px 0px 40px -21px rgb(0 0 0);\n}\n.login-container {\n    min-height: 100vh;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.uni-logo-login img {\n    width: 250px;\n    margin: 0px auto;\n    padding: 30px;\n    display: flex;\n    align-items: center;\n    filter: brightness(0) invert(1);\n}\n.uni-logo-login {\n    background-color: #005eef;\n    padding: 30px;\n}\n.sign-in-form {\n    color: #005eef;\n    padding: 20px;\n}\n.sign-in-form div h2 {\n    text-transform: uppercase;\n    margin-bottom: 0px !important;\n}\n.sign-in-form div p {\n    font-weight: 600;\n    margin-bottom: 0px !important;\n    letter-spacing: 1px;\n}\n.sign-in-box button {\n    width: 150px;\n    border-radius: 20px;\n    background-color: #005eef;\n    padding: 8px 10px;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.usage-layout-container {\n    padding: 16px;\n    font-family: Arial, sans-serif;\n}\n\n.usage-grid-header {\n    display: grid;\n    gap: 16px;\n    margin-bottom: 8px;\n    align-items: end;\n}\n\n.header-cell {\n    font-size: 14px;\n    font-weight: 600;\n    color: rgb(51, 94, 234);\n    min-height: 40px;\n    padding-bottom: 4px;\n}\n\n.header-cell.label-header {\n    text-align: left;\n}\n\n.header-cell.product-header {\n    text-align: center;\n}\n\n.usage-grid-container {\n    display: grid;\n    gap: 16px;\n}\n\n.grid-cell {\n    display: flex;\n    align-items: center;\n    border: 1px solid rgb(51, 94, 234);\n    border-radius: 8px;\n    height: 38px;\n    box-sizing: border-box;\n}\n\n.grid-cell.label-cell {\n    justify-content: flex-start;\n    padding-left: 16px;\n    font-size: 14px;\n    color: #333;\n}\n\n.grid-cell.data-cell {\n    padding: 0;\n}\n\n.table-input {\n    width: 100%;\n    height: 100%;\n    border: none;\n    outline: none;\n    padding: 8px 16px;\n    box-sizing: border-box;\n    text-align: center;\n    background-color: transparent;\n    font-size: 14px;\n    border-radius: 8px;\n}\n\n.table-input:read-only {\n    cursor: default;\n    color: #555;\n}\n\n.table-input.editable {\n    background-color: #fff;\n}\n\n.table-input.editable:focus {\n    box-shadow: 0 0 0 2px rgba(51, 94, 234, 0.4);\n}\n\n/* Text Theme Analysis */\n.tta-filter-header {\n    border-radius: 5px;\n}\n\n.tta-study-info-row {\n    align-items: baseline;\n    color: var(--color-blue);\n    display: flex;\n    flex-wrap: nowrap;\n    font-size: 9.5px;\n    line-height: 1.1;\n    overflow: hidden;\n    padding: 6px 0;\n    white-space: nowrap;\n    width: 100%;\n}\n\n.tta-study-info-item {\n    align-items: baseline;\n    display: flex;\n    flex: 0 0 auto;\n    white-space: nowrap;\n}\n\n.tta-study-info-row .text-xs {\n    font-size: 10.5px !important;\n    line-height: 1.1;\n}\n\n.tta-study-info-row .ps-2 {\n    padding-left: 0.35rem !important;\n}\n\n.tta-study-info-row .pe-3 {\n    padding-right: 0.55rem !important;\n}\n\n.tta-page {\n    min-height: calc(100vh - 150px);\n    padding: 7px 9px 82px 0;\n    position: relative;\n}\n\n.tta-back {\n    align-items: center;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    left: -15px;\n    position: absolute;\n    top: -15px;\n    z-index: 4;\n}\n\n.tta-main-content {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    padding-left: 0;\n}\n\n.tta-section-group {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.tta-section-wrapper {\n    display: grid;\n    gap: 3.5px;\n    grid-template-columns: 14px minmax(0, 1fr);\n}\n\n.tta-section-wrapper.without-label {\n    grid-template-columns: minmax(0, 1fr);\n}\n\n.tta-section-label {\n    align-items: center;\n    align-self: start;\n    border-radius: 0 14px 14px 0;\n    color: var(--color-white);\n    display: flex;\n    height: 123px;\n    justify-content: center;\n    margin-top: 132px;\n    padding: 5px 0;\n    width: 14px;\n}\n\n.tta-section-label span {\n    color: var(--color-white);\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 0;\n    transform: rotate(180deg);\n    white-space: nowrap;\n    writing-mode: vertical-rl;\n}\n\n.tta-section-content {\n    min-width: 0;\n}\n\n.tta-section-toolbar {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 5px;\n}\n\n.tta-section-toolbar img {\n    height: 14px;\n}\n\n.tta-section-toolbar .custom-btn {\n    font-size: 11px !important;\n    min-height: 28px;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.tta-section-toolbar .MuiSwitch-root {\n    transform: scale(0.88);\n}\n\n.tta-grid {\n    display: grid;\n    gap: 12px;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.tta-card {\n    border-radius: 6px;\n    padding: 8px 10px 10px;\n}\n\n.tta-card-title-row {\n    align-items: center;\n    display: flex;\n    gap: 7px;\n    font-size: 10.5px;\n    line-height: 1.2;\n    min-height: 19px;\n}\n\n.tta-card-title-row .table-head-product-buttons {\n    font-size: 9.5px;\n    font-weight: 500;\n}\n\n.tta-sample-size-wrapper {\n    flex: 0 0 auto;\n    line-height: 1;\n}\n\n.tta-sample-size-wrapper > span {\n    font-size: 10.5px !important;\n    line-height: 1 !important;\n}\n\n.tta-sample-size-wrapper .MuiSvgIcon-root {\n    font-size: 9.5px !important;\n    margin-left: 2px;\n    margin-top: -4px;\n}\n\n.tta-controls {\n    align-items: stretch;\n    display: grid;\n    gap: 3px;\n    grid-template-columns: minmax(0, 1fr) 92px 158px;\n    margin: 3px 0 5px;\n    min-width: 0;\n}\n\n.tta-display-dropdown {\n    position: relative;\n}\n\n.tta-display-dropdown > button {\n    align-items: center;\n    background-color: var(--color-white);\n    border: var(--table-head-border);\n    border-radius: 4px;\n    color: var(--light-black);\n    display: flex;\n    font-size: 10.5px;\n    gap: 4.5px;\n    height: 100%;\n    justify-content: flex-start;\n    min-height: 21px;\n    overflow: hidden;\n    padding: 0 6px;\n    text-align: left;\n    white-space: nowrap;\n    width: 100%;\n}\n\n.tta-display-dropdown > button span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.tta-display-dropdown > button span:not(.tta-display-prefix) {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.tta-display-dropdown > button .MuiSvgIcon-root {\n    flex: 0 0 auto;\n    font-size: 20px;\n    margin-left: auto;\n    stroke: var(--color-blue);\n    stroke-width: 1.6;\n}\n\n.tta-dropdown-chevron {\n    transition: transform 0.18s ease;\n}\n\n.tta-dropdown-chevron.open {\n    transform: rotate(180deg);\n}\n\n.tta-display-dropdown > button:disabled,\n.tta-filter-button.Mui-disabled,\n.tta-view-more:disabled {\n    cursor: default;\n    opacity: 0.45;\n    pointer-events: none;\n}\n\n.tta-chart-toggle-switch.disabled {\n    cursor: default;\n    opacity: 0.45;\n    pointer-events: none;\n}\n\n.tta-display-prefix {\n    color: var(--light-grey);\n    font-size: 9px;\n    font-style: italic;\n    opacity: 0.45;\n    white-space: nowrap;\n}\n\n.tta-display-menu {\n    background-color: var(--color-white);\n    border: var(--table-head-border);\n    box-shadow: var(--table-head-box-shadow);\n    left: 0;\n    position: absolute;\n    top: calc(100% + 2px);\n    width: 100%;\n    z-index: 7;\n}\n\n.tta-display-menu button {\n    background-color: var(--color-white);\n    border: none;\n    color: var(--light-black);\n    display: flex;\n    font-size: 9.5px;\n    gap: 5px;\n    padding: 7px 9px;\n    text-align: left;\n    width: 100%;\n}\n\n.tta-filter-wrapper {\n    position: relative;\n}\n\n.tta-filter-button {\n    height: 100%;\n    min-width: 100%;\n    font-size: 9.5px !important;\n    justify-content: center !important;\n    min-height: 21px !important;\n    padding-left: 4px !important;\n    padding-right: 4px !important;\n    width: 100% !important;\n}\n\n.tta-status-dot {\n    align-items: center;\n    border-radius: 50%;\n    display: inline-flex;\n    flex: 0 0 10px;\n    height: 10px;\n    justify-content: center;\n    margin-left: 3.5px;\n    width: 10px;\n}\n\n.tta-status-dot::after {\n    background-color: var(--color-white);\n    content: \"\";\n    height: 2px;\n    width: 6px;\n}\n\n.tta-status-dot.blue {\n    background-color: var(--color-blue);\n}\n\n.tta-status-dot.red {\n    background-color: red;\n}\n\n.tta-filter-menu {\n    background-color: var(--color-white);\n    display: grid;\n    grid-template-columns: 48% 52%;\n    min-height: 201px;\n    position: absolute;\n    right: 0;\n    top: calc(100% + 4px);\n    width: 348px;\n    z-index: 8;\n}\n\n.tta-filter-categories {\n    max-height: 320px;\n    overflow-y: auto;\n}\n\n.tta-filter-categories button {\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid var(--color-white);\n    color: var(--color-white);\n    display: block;\n    font-size: 9.5px;\n    font-weight: 700;\n    padding: 9px 14px;\n    text-align: left;\n    width: 100%;\n}\n\n.tta-filter-categories button.active {\n    text-decoration: underline;\n}\n\n.tta-filter-values {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    max-height: 320px;\n    overflow-y: auto;\n    padding: 9px;\n}\n\n.tta-filter-actions {\n    align-items: center;\n    border-bottom: var(--table-head-border);\n    display: flex;\n    font-size: 9.5px;\n    justify-content: space-between;\n    padding-bottom: 5px;\n}\n\n.tta-filter-checkbox,\n.tta-filter-actions label {\n    align-items: center;\n    color: var(--light-black);\n    display: flex;\n    font-size: 9.5px;\n    gap: 7px;\n}\n\n.tta-apply-button {\n    align-self: center;\n    border: 1px solid var(--color-blue);\n    border-radius: 4px;\n    font-size: 12px !important;\n    line-height: 1 !important;\n    margin-top: auto;\n    min-height: 28px !important;\n    min-width: 58px;\n    padding: 4px 16px !important;\n}\n\n.tta-filter-tooltip {\n    display: grid;\n    gap: 14px;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.tta-filter-tooltip p {\n    margin: 5px 0 0;\n}\n\n.tta-ui-tooltip,\n.tta-verbatim-tooltip {\n    background-color: var(--color-white) !important;\n    border: var(--table-head-border);\n    border-radius: 4px !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);\n    color: var(--light-black) !important;\n    font-size: 9px !important;\n    line-height: 1.35 !important;\n    max-width: 260px !important;\n    padding: 6px 8px !important;\n}\n\n.tta-chart-toggle-switch {\n    align-items: center;\n    background-color: var(--color-white);\n    border: 1px solid var(--light-blue);\n    border-radius: 4px;\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 0;\n    justify-content: center;\n    min-height: 21px;\n    min-width: 0;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n}\n\n.tta-chart-toggle-switch button {\n    background: transparent;\n    border: none;\n    color: var(--light-black);\n    cursor: pointer;\n    flex: 1 1 0;\n    font-size: 9.5px;\n    font-weight: 500;\n    min-height: 19px;\n    min-width: 0;\n    overflow: hidden;\n    padding: 0 3.5px;\n    position: relative;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    z-index: 2;\n}\n\n.tta-chart-toggle-switch .MuiSwitch-root {\n    flex: 0 0 auto;\n    transform: scale(0.82);\n}\n\n.tta-chart-toggle-switch button.active {\n    color: var(--color-blue);\n}\n\n.tta-analysis-frame {\n    background-color: var(--color-white);\n    column-gap: 8px;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 108px;\n    min-height: 290px;\n}\n\n.tta-analysis-frame.no-verbatim {\n    grid-template-columns: 1fr;\n}\n\n.tta-chart-area {\n    background-color: var(--table-head-background);\n    border-right: none;\n    min-height: 290px;\n    overflow: hidden;\n}\n\n.tta-analysis-frame.no-verbatim .tta-chart-area {\n    border-right: none;\n}\n\n.tta-chart-area.scrollable {\n    max-height: 290px;\n    overflow: hidden;\n}\n\n.tta-bar-chart {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: center;\n    padding: 25px 38px 32px 20px;\n    position: relative;\n}\n\n.tta-bar-chart.scrollable {\n    max-height: 290px;\n    overflow: hidden;\n}\n\n.tta-bar-list {\n    display: flex;\n    flex-direction: column;\n    gap: 22px;\n}\n\n.tta-bar-chart.scrollable .tta-bar-list {\n    margin-right: -34px;\n    max-height: 132px;\n    overflow-y: auto;\n    padding-right: 34px;\n    scrollbar-width: thin;\n}\n\n.tta-bar-chart.scrollable .tta-bar-list::-webkit-scrollbar {\n    width: 4px;\n}\n\n.tta-bar-chart.scrollable .tta-bar-list::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 4px;\n}\n\n.tta-bar-chart.scrollable .tta-bar-list::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.tta-bar-row {\n    align-items: center;\n    display: grid;\n    gap: 11px;\n    grid-template-columns: 100px minmax(185px, 1fr) 21px;\n}\n\n.tta-bar-label {\n    font-size: 9px;\n    font-weight: 500;\n    text-align: right;\n}\n\n.tta-bar-track {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    min-height: 23px;\n}\n\n.tta-bar {\n    background: #5596ed !important;\n    display: inline-block;\n    height: 21px;\n    width: var(--bar-width);\n}\n\n.tta-bar-value {\n    font-size: 9.5px;\n    font-weight: 500;\n}\n\n.tta-chart-footnote {\n    bottom: 16px;\n    font-size: 9.5px;\n    left: 0;\n    opacity: 0.75;\n    position: absolute;\n    text-align: center;\n    width: 100%;\n}\n\n.tta-web-chart {\n    height: 100%;\n    width: 100%;\n}\n\n.tta-no-data {\n    align-items: center;\n    color: var(--light-grey);\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    text-align: center;\n}\n\n.tta-verbatim-panel {\n    background-color: var(--table-head-background);\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    height: 290px;\n    margin: 0;\n    min-height: 0;\n    overflow: hidden;\n    padding: 10px 8px;\n}\n\n.tta-verbatim {\n    color: var(--light-black);\n    font-size: 8px;\n    min-height: 0;\n}\n\n.tta-verbatim p {\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    display: -webkit-box;\n    font-weight: 500;\n    line-clamp: 2;\n    margin: 4px 0;\n    overflow: hidden;\n}\n\n.tta-verbatim strong {\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    display: -webkit-box;\n    line-clamp: 2;\n    overflow: hidden;\n}\n\n.tta-verbatim-icon {\n    border-radius: 2px;\n    box-sizing: content-box;\n    font-size: 16px !important;\n    padding: 2px;\n}\n\n.tta-verbatim-icon.positive {\n    background-color: #d8ffd6;\n    color: green;\n}\n\n.tta-verbatim-icon.negative {\n    background-color: #ffe0e0;\n    color: red;\n}\n\n.tta-verbatim-icon.mixed {\n    height: 20px;\n    padding: 0;\n    width: 20px;\n}\n\n.tta-view-more {\n    align-items: center;\n    background-color: #e9e9e9;\n    border: none;\n    border-radius: 4px;\n    color: var(--light-black);\n    display: flex;\n    font-size: 9px;\n    gap: 7px;\n    justify-content: center;\n    margin-top: auto;\n    min-height: 24px;\n}\n\n.tta-view-more-icon {\n    flex: 0 0 auto;\n    height: 18px;\n    stroke: currentColor;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 2;\n    width: 18px;\n}\n\n.tta-warning {\n    align-items: center;\n    display: flex;\n    font-size: 9px;\n    gap: 5px;\n    margin-top: 7px;\n    opacity: 0.7;\n}\n\n.tta-question {\n    font-size: 9px;\n    font-weight: 500;\n    margin: 6px 0 3px;\n}\n\n.tta-summary {\n    align-items: flex-start;\n    background-color: var(--table-head-background);\n    border: var(--table-head-border);\n    border-radius: 4px;\n    color: var(--light-black);\n    display: flex;\n    font-size: 9px;\n    gap: 9px;\n    line-height: 1.35;\n    min-height: 34px;\n    padding: 5px 8px;\n}\n\n.tta-summary-content {\n    flex: 1;\n    min-width: 0;\n}\n\n.tta-summary-text {\n    display: block;\n}\n\n.tta-summary-text.clamped {\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    display: -webkit-box;\n    line-clamp: 2;\n    overflow: hidden;\n}\n\n.tta-summary-toggle {\n    font-size: 9px;\n    font-weight: 600;\n    margin-left: 4px;\n}\n\n.tta-summary .MuiSvgIcon-root {\n    font-size: 16px !important;\n}\n\n.tta-dialog-paper {\n    border-radius: 4px !important;\n    max-height: 70vh !important;\n    max-width: 82vw !important;\n    width: 82vw !important;\n}\n\n.tta-dialog-title {\n    background-color: var(--table-head-background);\n    color: var(--color-blue);\n    font-size: 14px !important;\n    font-weight: 700 !important;\n    padding: 18px 44px !important;\n    text-align: center;\n}\n\n.tta-dialog-close {\n    position: absolute !important;\n    right: 12px;\n    top: 10px;\n}\n\n.tta-dialog-content {\n    max-height: calc(70vh - 58px);\n    overflow-y: auto;\n    padding: 34px 58px !important;\n}\n\n.tta-modal-grid {\n    display: grid;\n    gap: 48px;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    padding: 0;\n}\n\n.tta-modal-grid strong {\n    color: var(--light-black);\n    font-size: 13px;\n}\n\n.tta-modal-grid p {\n    border-bottom: 0;\n    color: var(--light-black);\n    font-size: 11px;\n    line-height: 1.45;\n    margin: 22px 0 0;\n    padding-bottom: 0;\n}\n\n.tta-variable-tabs {\n    align-items: flex-end;\n    bottom: 28px;\n    display: flex;\n    left: 0;\n    max-width: calc(100% - 32px);\n    overflow-x: auto;\n    padding-bottom: 6px;\n    position: absolute;\n}\n\n.tta-variable-tabs::-webkit-scrollbar {\n    height: 4px;\n}\n\n.tta-variable-tabs::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.18);\n    border-radius: 4px;\n}\n\n.tta-variable-tabs::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.tta-variable-tabs button {\n    background: var(--light-blue-gradient-background-2);\n    border: var(--table-head-border);\n    border-bottom: none;\n    clip-path: polygon(0 0, 100% 0, calc(100% - 28px) 100%, 0 100%);\n    color: var(--color-white);\n    cursor: pointer;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1;\n    min-height: 36px;\n    min-width: 230px;\n    padding: 10px 38px 10px 24px;\n}\n\n.tta-variable-tabs button + button {\n    clip-path: polygon(28px 0, 100% 0, calc(100% - 28px) 100%, 0 100%);\n    margin-left: -28px;\n    padding-left: 48px;\n}\n\n.tta-variable-tabs button.active {\n    background: var(--light-blue-gradient-background);\n    color: var(--light-black);\n    position: relative;\n    z-index: 1;\n}\n\n.tta-variable-tabs button span {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.text-theme-selection-cell {\n    align-items: center;\n    display: inline-flex;\n    gap: 7px;\n    justify-content: center;\n}\n\n@media (max-width: 1200px) {\n    .tta-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .tta-controls {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
